<template>
  <div v-if="preloader === true">
    <template>
      <div class="d-flex align-center justify-center flex-column" style="height: 100vh;">
        <bubble-loader />
      </div>
    </template>
  </div>
  <div v-else>
    <div v-if="scheduleInterviewDialog">
      <v-dialog max-width="1020px" width="90%" class="cdz" v-model="scheduleInterviewDialog" center>
        <ScheduleInterView @closeDialog="manageDialog" :userData="currentUserDataForScheduleInterview" />
      </v-dialog>
    </div>
    <div v-if="isHrAction">
      <v-dialog v-model="isHrAction" class="cdz" max-width="366px" persistent>
        <v-card fluid>
          <v-container fluid class="pa-0">
            <v-card-text class="text-center">
              <v-avatar color="background" size="90">
                <v-icon class="mail-icon" size="65">mdi-email</v-icon>
              </v-avatar>
              <p class="text-h5 pt-4 pb-0">Send Mail</p>
              <p class="text-disabled grey--text text-subtitle-1" color="rgba(0, 0, 0, 0.6)" disabled>
                Do you wish to initiate the next round?
              </p>
              <div class="d-flex justify-space-between pt-4 pb-2" fluid>
                <v-btn depressed class="btn outline-btn" large width="157px" rounded
                  @click="isHrAction = false">CANCEL</v-btn>
                <v-btn class="btn primary-btn" depressed large width="157px" rounded :loading="dLoading"
                  @click="sendHrEvalMail">SEND</v-btn>
              </div>
            </v-card-text>
          </v-container>
        </v-card>
      </v-dialog>
    </div>
    <v-card width="100%"
      class="background ml-4 mr-6 my-0 px-4 transparent elevation-0 d-flex flex-row justify-space-between align-center"
      style="
        position: fixed;
        z-index: 200;
        top: 0;
        width: 98%;
        padding-top: 16px;
        ">
      <v-card-title class="pl-0 ml-0">
        <p class="breadcrumb-text-unselected underline-on-hover cursor" @click="$router.push('/campaign')">
          Campaigns
        </p>
        <v-icon class="breadcrumb-arrow-unselected" style="margin-top: 6px !important">mdi-chevron-right</v-icon>
        <p class="breadcrumb-text" style="margin-top: 2px">{{ campaignName }}</p>
        <v-icon class="breadcrumb-arrow" style="margin-top: 5px !important">mdi-chevron-down</v-icon>
      </v-card-title>
      <UserNavMenu />
    </v-card>
    <div fluid class="px-8 pad">
      <v-dialog v-model="filterDialog" class="cdz" max-width="570px">
        <v-card width="1000px" height="100%" class="filterDialogClass">
          <v-row class="mt-4 mx-1">
            <v-col>
              <div class="pl-0 mb-2 text-body1 font-weight-bold grey--text">
                Filter
              </div>
            </v-col>
            <v-col class="d-flex justify-end">
              <div @click="clearFilter" class="clear-filter-btn">
                Clear Filter
              </div>
            </v-col>
          </v-row>
          <v-tabs vertical>
            <div class="ml-3 mt-4 mr-4 filterLine hide-scrollbar">
              <v-tab v-if="!campaignMetaData?.isExternalClient" class="black--text justify-start"
                active-class="activeTab">
                <span>Source</span>
                <span v-if="selectedSourceFilter.length > 0" class="ml-1">({{ selectedSourceFilter.length }})</span>
              </v-tab>
              <v-tab v-if="!campaignMetaData?.isExternalClient" class="black--text justify-start"
                active-class="activeTab">
                <span>Candidate Decision</span>
                <span v-if="selectedCandidateDecisionFilter.length > 0" class="ml-1">({{
                  selectedCandidateDecisionFilter.length }})</span>
              </v-tab>
              <v-tab v-if="this.$store.state.userInfo?.role?.schools == 'All' && !campaignMetaData?.isExternalClient"
                class="black--text justify-start" active-class="activeTab">
                <span>School Cities </span>
                <span v-if="selectedSchoolCitiesFilter.length > 0" class="ml-1">({{ selectedSchoolCitiesFilter.length
                  }})</span>
              </v-tab>
              <v-tab
                v-if="this.$store.state.userInfo?.role?.clusterName == 'All Clusters' && !campaignMetaData?.isExternalClient"
                class="black--text justify-start" active-class="activeTab">
                <span>Clusters</span>
                <span v-if="selectedClusterFilters.length > 0" class="ml-1">({{ selectedClusterFilters.length }})</span>
              </v-tab>
              <v-tab v-if="this.$store.state.userInfo?.role?.schools == 'All' && !campaignMetaData?.isExternalClient"
                class="black--text justify-start" active-class="activeTab">
                <span>Preferred Location </span>
                <span v-if="selectedLocationFilters.length > 0" class="ml-1">({{ selectedLocationFilters.length
                  }})</span>
              </v-tab>
              <v-tab class="black--text justify-start" active-class="activeTab">
                <span>Created On</span>
                <span v-if="selectedDateFilters" class="ml-1">({{ 1 }})</span>
              </v-tab>
              <v-tab class="black--text justify-start" active-class="activeTab">
                <span>Group</span>
                <span v-if="selectedGroupFilter.length > 0" class="ml-1">({{ selectedGroupFilter.length }})</span>
              </v-tab>
              <v-tab v-if="!campaignMetaData?.isExternalClient" class="black--text justify-start"
                active-class="activeTab">
                <span>Departments</span>
                <span v-if="selectedDepartmentFilter.length > 0" class="ml-1">({{ selectedDepartmentFilter.length
                  }})</span>
              </v-tab>
              <v-tab v-if="!campaignMetaData?.isExternalClient" class="black--text justify-start"
                active-class="activeTab">
                <span>Preferred Job Role</span>
                <span v-if="selectedJobRolesFilters.length > 0" class="ml-1">({{ selectedJobRolesFilters.length
                  }})</span>
              </v-tab>
              <v-tab v-if="!campaignMetaData?.isExternalClient" class="black--text justify-start"
                active-class="activeTab">
                <span>Screening (quick fitment check)</span>
                <span v-if="selectedScreeningFilters.length > 0" class="ml-1">({{ selectedScreeningFilters.length
                  }})</span>
              </v-tab>
              <v-tab class="black--text justify-start" active-class="activeTab">
                <span>Mains (detail fitment check)</span>
                <span v-if="selectedMainsFilters.length > 0" class="ml-1">({{ selectedMainsFilters.length }})</span>
              </v-tab>
              <v-tab v-if="!campaignMetaData?.isExternalClient" class="black--text justify-start"
                active-class="activeTab">
                <span>Demo Submitted</span>
                <span v-if="selectedDemoFilters.length > 0" class="ml-1">({{ selectedDemoFilters.length }})</span>
              </v-tab>
              <v-tab v-if="!campaignMetaData?.isExternalClient" class="black--text justify-start"
                active-class="activeTab">
                <span>Interview Status</span>
                <span v-if="selectedInterviewsFilters.length > 0" class="ml-1">({{ selectedInterviewsFilters.length
                  }})</span>
              </v-tab>
              <v-tab v-if="!campaignMetaData?.isExternalClient" class="black--text justify-start"
                active-class="activeTab">
                <span>League</span>
                <span v-if="selectedLeagueFilters.length > 0" class="ml-1">({{ selectedLeagueFilters.length }})</span>
              </v-tab>
              <v-tab v-if="!campaignMetaData?.isExternalClient" class="black--text justify-start"
                active-class="activeTab">
                <span>Subject</span>
                <span v-if="selectedSubjectFilters.length > 0" class="ml-1">({{ selectedSubjectFilters.length }})</span>
              </v-tab>
              <v-tab v-if="!campaignMetaData?.isExternalClient" class="black--text justify-start"
                active-class="activeTab">
                <span>Rank</span>
                <span v-if="selectedRankFilters" class="ml-1">({{ 1 }})</span>
              </v-tab>
              <v-tab class="black--text justify-start" active-class="activeTab">
                <span>Level</span>
                <span v-if="selectedLevelFilters.length > 0" class="ml-1">({{ selectedLevelFilters.length }})</span>
              </v-tab>
            </div>
            <v-tab-item v-if="!campaignMetaData?.isExternalClient">
              <v-card flat class="school-filter">
                <v-card-text>
                  <v-chip-group v-model="selectedSourceFilter" active-class="active-chip" column :multiple="true">
                    <v-chip v-for="(source, index) in sourceData" :key="index" :value="source" elevated>
                      {{ source }}
                    </v-chip>
                  </v-chip-group>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item v-if="!campaignMetaData?.isExternalClient">
              <v-card flat class="school-filter">
                <v-card-text>
                  <h4>After Candidate Onboarding</h4>
                  <v-chip-group v-model="selectedOnBoardingDecisionFilter" active-class="active-chip" column
                    :multiple="true" @change="updateDecisionStatusFilter">
                    <v-chip v-for="(decision, index) in decisionData" :key="index" :value="decision.value" elevated>
                      {{ decision.text }}
                    </v-chip>
                  </v-chip-group>
                  <h4>After Quick Fitment Check</h4>
                  <v-chip-group v-model="selectedAfterScreeningDecisionFilter" active-class="active-chip" column
                    :multiple="true" @change="updateDecisionStatusFilter">
                    <v-chip v-for="(decision, index) in decisionData" :key="index" :value="decision.value" elevated>
                      {{ decision.text }}
                    </v-chip>
                  </v-chip-group>
                  <h4>After Detail Fitment Check</h4>
                  <v-chip-group v-model="selectedAfterMainsDecisionFilter" active-class="active-chip" column
                    :multiple="true" @change="updateDecisionStatusFilter">
                    <v-chip v-for="(decision, index) in decisionData" :key="index" :value="decision.value" elevated>
                      {{ decision.text }}
                    </v-chip>
                  </v-chip-group>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item
              v-if="this.$store.state.userInfo?.role?.clusterName == 'All Clusters' && !campaignMetaData?.isExternalClient">
              <v-card flat class="school-filter">
                <v-card-text>
                  <v-chip-group v-model="selectedSchoolCitiesFilter" active-class="active-chip" column :multiple="true">
                    <v-chip v-for="(schoolCity, index) in schoolCitiesData" :key="index" :value="schoolCity" elevated>
                      {{ schoolCity }}
                    </v-chip>
                  </v-chip-group>
                  Please select Cluster or School to fetch the results.
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item
              v-if="this.$store.state.userInfo?.role?.clusterName == 'All Clusters' && !campaignMetaData?.isExternalClient">
              <v-card flat class="school-filter">
                <v-card-text>
                  <v-chip-group v-model="selectedClusterFilters" active-class="active-chip" column :multiple="true">
                    <v-chip v-for="(clusterType, index) in clusterData" :key="index" :value="clusterType" elevated>
                      {{ clusterType }}
                    </v-chip>
                  </v-chip-group>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item
              v-if="this.$store.state.userInfo?.role?.schools == 'All' && !campaignMetaData?.isExternalClient">
              <v-card flat class="school-filter" v-if="selectedClusterFilters.length >= 1">
                <FilterSearch :items="preferredLocation" v-model="selectedLocationFilters"
                  search-label="Search locations..." />
              </v-card>
              <v-card v-else>
                <p>Please select cluster</p>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat class="school-filter">
                <v-card-text>
                  <v-chip-group v-model="selectedDateFilters" active-class="active-chip" column>
                    <v-chip v-for="(date, index) in dateData" :key="index" :value="date.value" elevated>
                      {{ date.name }}
                    </v-chip>
                    <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-chip :value="'custom_date'" v-bind="attrs" v-on="on" elevated active-class="active-chip">
                          Custom Dates
                        </v-chip>
                      </template>
                      <v-card>
                        <v-card-title>Select Dates</v-card-title>
                        <v-card-text>
                          <v-row>
                            <v-col>
                              <v-menu ref="menu" v-model="menuStart" :close-on-content-click="false"
                                transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field class="custom-date-picker" v-bind="attrs" v-on="on" label="Start Date"
                                    prepend-icon="mdi-calendar" v-model="customStartDate" readonly></v-text-field>
                                </template>
                                <v-date-picker class="custom-date-picker" v-model="customStartDate"
                                  @input="menuStart = false"></v-date-picker>
                              </v-menu>
                            </v-col>
                            <v-col>
                              <v-menu ref="menu" v-model="menuEnd" :close-on-content-click="false"
                                transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field class="custom-date-picker" v-bind="attrs" v-on="on" label="End Date"
                                    prepend-icon="mdi-calendar" v-model="customEndDate" readonly></v-text-field>
                                </template>
                                <v-date-picker class="custom-date-picker" v-model="customEndDate"
                                  @input="menuEnd = false"></v-date-picker>
                              </v-menu>
                            </v-col>
                          </v-row>
                        </v-card-text>
                        <v-card-actions>
                          <v-btn class="btn primary-btn" @click="addCustomDates">Ok</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-menu>
                  </v-chip-group>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat class="school-filter">
                <v-card-text>
                  <v-chip-group v-model="selectedGroupFilter" active-class="active-chip" column :multiple="true">
                    <v-chip v-for="(group, index) in groupData" :key="index" :value="group" elevated>
                      {{ group }}
                    </v-chip>
                  </v-chip-group>
                  Please select at least one group.
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item v-if="!campaignMetaData?.isExternalClient">
              <v-card flat class="school-filter">
                <v-card-text>
                  <v-chip-group v-model="selectedDepartmentFilter" active-class="active-chip" column :multiple="true">
                    <v-chip v-for="(department, index) in departmentData" :key="index" :value="department" elevated>
                      {{ department }}
                    </v-chip>
                  </v-chip-group>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item v-if="!campaignMetaData?.isExternalClient">
              <v-card flat class="school-filter">

                <FilterSearch :items="jobRolesData" v-model="selectedJobRolesFilters"
                  search-label="Search Job Roles..." />
              </v-card>
            </v-tab-item>
            <v-tab-item v-if="!campaignMetaData?.isExternalClient">
              <v-card flat class="school-filter">
                <v-card-text>
                  <v-chip-group v-model="selectedScreeningFilters" active-class="active-chip" column :multiple="true">
                    <v-chip v-for="(screening, index) in screeningData" :key="index" :value="screening.value" elevated>
                      {{ screening.name }}
                    </v-chip>
                  </v-chip-group>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item v-if="!campaignMetaData?.isExternalClient">
              <v-card flat class="school-filter">
                <v-card-text>
                  <v-chip-group v-model="selectedMainsFilters" active-class="active-chip" column :multiple="true">
                    <v-chip v-for="(mains, index) in mainsData" :key="index" :value="mains.value" elevated>
                      {{ mains.name }}
                    </v-chip>
                  </v-chip-group>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item v-else>
              <v-card flat class="school-filter">
                <v-card-text>
                  <v-chip-group v-model="selectedMainsFilters" active-class="active-chip" column :multiple="true">
                    <v-chip v-for="(status, index) in statusData" :key="index" :value="status.value" elevated>
                      {{ status.name }}
                    </v-chip>
                  </v-chip-group>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item v-if="!campaignMetaData?.isExternalClient">
              <v-card flat class="school-filter">
                <v-card-text>
                  <v-chip-group v-model="selectedDemoFilters" active-class="active-chip" column :multiple="true">
                    <v-chip v-for="(demo, index) in demoData" :key="index" :value="demo.value" elevated>
                      {{ demo.name }}
                    </v-chip>
                  </v-chip-group>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item v-if="!campaignMetaData?.isExternalClient">
              <v-card flat class="school-filter">
                <v-card-text>
                  <v-chip-group v-model="selectedInterviewsFilters" active-class="active-chip" column :multiple="true"
                    @change="updateSelectedRounds">
                    <v-chip v-for="(interview, index) in interviewsData" :key="index" :value="index" elevated>
                      {{ interview?.text }}
                    </v-chip>
                  </v-chip-group>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item v-if="!campaignMetaData?.isExternalClient">
              <v-card flat class="school-filter">
                <v-card-text>
                  <v-chip-group v-model="selectedLeagueFilters" active-class="active-chip" column :multiple="true">
                    <v-chip v-for="(league, index) in leagueData" :key="index" :value="league" elevated>
                      {{ league }}
                    </v-chip>
                  </v-chip-group>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item v-if="!campaignMetaData?.isExternalClient">
              <v-card flat class="school-filter">
                <FilterSearch :items="subjectData" v-model="selectedSubjectFilters" search-label="Search Subjects..." />
              </v-card>
            </v-tab-item>
            <v-tab-item v-if="!campaignMetaData?.isExternalClient">
              <v-card flat class="school-filter">
                <v-card-text v-if="selectedSubjectFilters.length === 1">
                  <v-chip-group v-model="selectedRankFilters" active-class="active-chip" column>
                    <v-chip v-for="(rank, index) in rankData" :key="index" :value="rank.name" elevated>
                      {{ rank.name }}
                    </v-chip>
                  </v-chip-group>
                </v-card-text>
                <v-card-text v-else>
                  <p>Please select only one subject to filter rankings.</p>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat class="school-filter">
                <v-card-text>
                  <v-chip-group v-model="selectedLevelFilters" active-class="active-chip" column :multiple="true">
                    <v-chip v-for="(level, index) in levelData" :key="index" :value="level" elevated>
                      {{ level }}
                    </v-chip>
                  </v-chip-group>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>
          <div class="filterDialogButton">
            <v-card-actions class="px-6 pb-0">
              <v-spacer></v-spacer>
              <v-btn rounded outlined class="btn outline-btn pa-4" @click="filterDialog = false">Cancel</v-btn>
              <v-btn :disabled="!isFilterEnable" :loading="isFilterLoading" rounded class="btn primary-btn pa-4" @click="
                options.page = 1,
                (appliedFilter = true),
                getFilterCount(),
                fetchCampaignAudience(),
                filterDialog = false
                ">Apply</v-btn>
            </v-card-actions>
          </div>
        </v-card>
      </v-dialog>
      <v-dialog v-model="qrDialog" class="cdz" persistent max-width="380px">
        <v-card>
          <v-card-text class="text-center d-flex flex-column justify-center align-center">
            <div class="d-flex justify-space-between w-100">
              <h2 class="pt-4">Share</h2>
              <span>
                <v-icon size="24" class="pt-4" @click="qrDialog = false">mdi-close</v-icon>
              </span>
            </div>
            <div ref="qrDownloadRef">
              <VueQRCodeComponent style="
                       display: flex;
                       justify-content: center;
                       margin-bottom: 8px;
                       padding: 16px;
                       " :text="qrCampaignLink" error-level="L"></VueQRCodeComponent>
            </div>
            <h4 class="w-100 text-left">Link</h4>
            <div style="border: 1px solid; border-radius: 8px;"
              class="px-6 py-3 ma-2 w-100 d-flex justify-space-between">
              <span>{{ shortCampaignLink }}</span>
              <div class="copy-image">
                <v-img max-width="100%" height="100%" v-bind="attrs" v-on="on" :src="require(`@/assets/copy_1.svg`)"
                  @click="copyLink" />
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="notificationDialog" class="cdz" max-width="380px">
        <Notification @close-dialog="notificationDialog = false" />
      </v-dialog>
      <v-dialog v-model="leagueDialog" class="cdz" max-width="500px">
        <v-card rounded="0" elevation="0" color="#D8D5C3" class="d-flex flex-row justify-space-between">
          <v-card-title class="font-weight-bold">League</v-card-title>
          <v-icon @click="leagueDialog = false" class="mr-4">mdi-close</v-icon>
        </v-card>
        <v-card rounded="0" elevation="0">
          <v-card-title class="font-weight-medium">{{
            this.userName
          }}
          </v-card-title>
          <v-card-title class="text-body-1 font-weight-medium py-0">
            <v-row>
              <v-col cols="3">League</v-col>
              <v-col cols="2">Rank</v-col>
              <v-col cols="4">Subject</v-col>
              <v-col cols="3">Percentile</v-col>
            </v-row>
          </v-card-title>
        </v-card>
        <v-card rounded="0" class="pb-2" elevation="0">
          <v-card-title v-for="(skill, index) in this.coreSkillsList" :key="index"
            class="text-body-1 font-weight-regular">
            <v-row>
              <v-col cols="3">
                <div class="d-flex flex-column ml-3">
                  <img height="23px" width="25" :src="skill.leagueValueIcon" />
                </div>
              </v-col>
              <v-col cols="2">
                <div class="d-flex flex-column ml-1">#{{ skill.rank }}</div>
              </v-col>
              <v-col cols="4">
                <div class="d-flex flex-column">
                  {{ skill.skillName }}
                </div>
              </v-col>
              <v-col cols="3">
                <div class="d-flex flex-column ml-4">
                  {{ skill?.percentile?.toFixed(2) || '' }}%
                </div>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-dialog>
      <v-dialog v-model="restartAssessmentDialog" max-width="380px" class="cdz" persistent>
        <v-card fluid>
          <v-container fluid class="p-6">
            <v-card-text class="text-center">
              <p class="text-h5 pb-0">Restart Assessment
              </p>
              <p class="text-disabled grey--text text-subtitle-1 pt-3" color="rgba(0, 0, 0, 0.6)" disabled>
                Do you want to restart the assessment?
              </p>
              <div class="d-flex justify-space-between pt-4 pb-2" fluid>
                <v-btn depressed class="btn outline-btn" large width="157px" outlined rounded
                  @click="restartAssessmentDialog = false;">Cancel</v-btn>
                <v-btn class="btn primary-btn" depressed large width="157px" rounded :loading="restartAssessmentLoader"
                  @click="clearUserAssessment(userForClearAssessment)">Restart
                </v-btn>
              </div>
            </v-card-text>
          </v-container>
        </v-card>
      </v-dialog>
      <v-dialog v-if="closeApplicationSuccessDialog" v-model="closeApplicationSuccessDialog" max-width="366px"
        persistent class="rounded-lg">
        <v-card>
          <v-container fluid class="pa-8">
            <v-card-text class="d-flex flex-column align-center">
              <img class="cursor" width="96px" height="96px" :src="successIcon" />
              <p class="text-h5 text-center py-4">
                Application Closed Successfully
              </p>
              <v-btn class="btn primary-btn" large width="180px" rounded
                @click="closeApplicationSuccessDialog = false">Ok</v-btn>
            </v-card-text>
          </v-container>
        </v-card>
      </v-dialog>
      <v-dialog max-width="1080px" v-model="viewFeedbackDialog" content-class="rounded-lg">
        <v-card class="pa-6 d-flex flex-column gap-4 rounded-lg view-feedback-dialog">
          <div>
            <div class="d-flex align-center justify-space-between">
              <div class="close-application-dialog-title">
                View Feedback ({{ receivedFeedbackCount }}/{{ totalFeedbackCount }})
              </div>
               <div>
              <v-btn-toggle
                v-if="feedbackRounds.length"
                v-model="selectedRound"
                @change="loadRoundFeedback"
                mandatory
                dense
                rounded
                class="round-toggle mr-2"
              >
                <v-btn
                  v-for="round in feedbackRounds"
                  :key="round"
                  :value="round"
                  :class="getFeedbackRoundButtonClass(round)"
                  width="100px"
                >
                  Round {{ round }}
                </v-btn>
              </v-btn-toggle>
               <v-btn v-if="downloadAttendanceReport" icon :loading="downloadingFeedback" @click="downloadAttendanceCSV" title="Download CSV"><v-img src="../assets/svg/import-icon.svg" /></v-btn>
              </div>
              </div>
            <div class="feedback-help-text mt-1">
              Click on the cards to view detailed scores and recommendations.
            </div>
          </div>
          <div class="feedback-scroll-container pa-1">
            <div class="feedback-grid">
              <div
                v-for="feedback in currentRoundFeedback"
                :key="feedback.interviewerEmail"
                class="feedback-card feedback-card--clickable elevation-2 pa-4 rounded-lg"
                :class="feedback.bgClass"
                @click="openInterviewerFeedbackDetail(feedback)"
              >
                <p class="feedback-card--name mb-2">{{ feedback.interviewerName }}</p>
                <div class="d-flex feedback-card--row">
                  <span class="feedback-card--label">Score</span>
                  <span class="feedback-card--dash">-</span>
                  <span class="feedback-card--value">{{ feedback.avgScore }}</span>
                </div>
                <div class="d-flex feedback-card--row">
                  <span class="feedback-card--label">Recommendation</span>
                  <span class="feedback-card--dash">-</span>
                  <span class="feedback-card--value">{{ feedback.recommendation }}</span>
                </div>
                <div class="d-flex feedback-card--row feedback-card--comment-row">
                  <span class="feedback-card--label">Comment</span>
                  <span class="feedback-card--dash">-</span>
                  <v-tooltip bottom max-width="320" :disabled="!truncatedComments[feedback.interviewerEmail]">
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        ref="commentRefs"
                        class="feedback-card--value feedback-card--comment"
                        :data-interviewer="feedback.interviewerEmail"
                        v-bind="attrs"
                        v-on="on"
                      >{{ feedback.remark }}</span>
                    </template>
                    <span class="feedback-comment-tooltip">{{ feedback.remark }}</span>
                  </v-tooltip>
                </div>
              </div>
              <div
                v-for="pendingFeedback in pendingCurrentRoundfeedback"
                :key="pendingFeedback.email || pendingFeedback"
                class="feedback-card feedback-card--pending rounded-xl elevation-2 pa-4"
              >
                <p class="feedback-card--name mb-2">{{ pendingFeedback.name || pendingFeedback }}</p>
                <p class="feedback-card--pending-text">Pending</p>
              </div>
            </div>
          </div>
          <div class="d-flex justify-end align-center">
            <v-btn @click="viewFeedbackDialog = false" depressed class="btn outline-btn mx-2" large outlined rounded>
              Close
            </v-btn>
          </div>
        </v-card>
      </v-dialog>
      <InterviewFeedbackDialog
        v-model="interviewFeedbackDetailDialog"
        :personalInfo="detailFeedbackPersonalInfo"
        :interviewDetails="detailFeedbackInterviewDetails"
        :proctoringPic="detailFeedbackProctoringPic"
        :interViewFeedback="detailFeedbackList"
        :interviewerEmail="detailFeedbackInterviewerEmail"
        :round="detailFeedbackRound"
      />
      <v-dialog max-width="826px" v-if="closeApplicationDialog" v-model="closeApplicationDialog">
        <v-card class="pa-6 d-flex flex-column gap-4">
          <div class="close-application-dialog-title">
            Close Application
          </div>
          <div class="close-application-dialog-text">
            Remarks*
          </div>
          <div>
            <ckeditor :config="editorConfig" v-model="closeApplicationForUser.remarksInfo.remarks" class="m-ckeditor"
              @ready="onEditorReady" @input="onEditorInput" :name="'ckeditor'">
            </ckeditor>
            <div class="text-right mt-2 text-caption"
              :class="remarksLength > maxRemarksCharacters ? 'red--text' : 'grey--text'">
              {{ remarksLength }} / {{ maxRemarksCharacters }} characters
            </div>
          </div>


          <div class="close-application-dialog-text">
            Note - Please summarize your reason for closing this application.
          </div>
          <div class="d-flex justify-end align-center">
            <v-btn @click="closeApplicationDialog = false" depressed class="btn outline-btn mx-2" large outlined
              rounded>
              Cancel
            </v-btn>
            <v-btn :disabled="remarksLength === 0 || remarksLength > maxRemarksCharacters" @click="closeApplication"
              :loading="closeApplicationLoader" depressed rounded class="btn primary-btn">
              Submit
            </v-btn>
          </div>
        </v-card>
      </v-dialog>
      <!-- <VueHtml2pdf :show-layout="false" :float-layout="true" :enable-download="true" :preview-modal="false"
           :paginate-elements-by-height="1400" filename="user-report" :pdf-quality="2" :manual-pagination="true"
           pdf-format="a4" :pdf-margin="10" pdf-orientation="portrait" pdf-content-width="800px" ref="html2Pdf"
           @progress=onProgress($event)>
           <section slot="pdf-content">
             <v-card class="w-85" height="100%" elevation="0">
               <v-list>
                 <v-list-item v-for="( item, index ) in  selectedSkill.questions " :key="index">
                   <v-col>
                     <v-row>
                       <div>Q.{{ index + 1 }}</div>
                       <div class="pl-4">{{ item.questionStatement }}</div>
                     </v-row>
                     <v-row class="pl-8 pt-2">
                       <v-chip v-if="item.difficultyLevel != 'NA'" small class="mr-2">{{ item.difficultyLevel }}</v-chip>
                       <v-chip v-if="item.complexityLevel != 'NA'" small class="mr-2">{{ item.complexityLevel }}</v-chip>
                       <v-chip v-if="item.knowledgeLevel != 'NA'" small class="mr-2">{{ item.knowledgeLevel }}</v-chip>
                       <v-chip v-if="item.level != 'NA'" small class="mr-2">{{ item.level }}</v-chip>
                     </v-row>
                     <v-layout wrap row class="pl-9 pt-2">
                       <div class="pr-3">Options -</div>
                       <div v-for="( option, i ) in  item.questionOptions " :key="i">
                         <div :class="item.correctAnswer === option.optionKey
                           ? 'pr-3 mt-1 text-body-2 green--text'
                           : 'pr-3 mt-1 text-body-2'
                           ">
                           {{ option.optionKey }}. {{ option.optionValue }}
                         </div>
                       </div>
                     </v-layout>
                     <v-row class="pl-8 pt-2">
                       <div class="pl-1 text-body-2">Time allocated -</div>
                       <div class="pl-1 text-subtitle-2">
                         {{ item.estimatedTime }} Sec
                       </div>
                       <v-spacer></v-spacer>
                       <div class="pl-1 text-body-2">
                         Avg time taken by other users -
                       </div>
                       <div v-if="(!item.averageTimeTaken)" class="pl-1 text-subtitle-2">NA</div>
                       <div v-else class="pl-1 text-subtitle-2">{{ item.averageTimeTaken.toFixed(2) }}</div>
                       <v-spacer></v-spacer>
                       <div class="pl-1 text-body-2">
                         People answered correctly -
                       </div>
                       <div v-if="(!item.noOfAttempt) && (!item.noOfCorrectAttempt)" class="pl-1 text-subtitle-2">NA</div>
                       <div v-else-if="(!item.noOfCorrectAttempt) && (item.noOfAttempt)" class="pl-1 text-subtitle-2">0%
                       </div>
                       <div v-else class="pl-1 text-subtitle-2">{{ (item.noOfCorrectAttempt / item.noOfAttempt) * 100 }}%
                       </div>
                     </v-row>
                     <v-row class="px-0 pl-9">
                       <v-divider></v-divider>
                     </v-row>
                     <v-row class="pl-9 pt-2 text-subtitle-2">
           
                       <div>Response Analytics -
           
                         <span v-if="(!item.myAnswer)">Not Attempted</span>
                         <span v-else>Attempted</span>
           
                       </div>
                     </v-row>
                     <v-row class="pl-9 text-body-2">
                       <div>Answered - </div>
                       <div v-if="(!item.myAnswer)"> Skipped</div>
                       <div v-else :class="item.correctAnswer === item.myAnswer
                         ? 'pl-1 green--text'
                         : 'pl-1 red--text'
                         ">
                         {{
                           item.correctAnswer === item.myAnswer
                           ? item.myAnswer + " (Correct)"
                           : item.myAnswer + " (Incorrect)"
                         }}
                       </div>
           
                     </v-row>
                     <v-row class="pl-9 text-body-2">
                       <div>Time taken -</div>
                       <div v-if="item.timeTaken != null" class="pl-1">
                         {{ item.timeTaken.toFixed(2) }} Sec
                       </div>
                     </v-row>
                     <v-row class="px-0 pl-9">
                       <v-divider></v-divider>
                     </v-row>
                   </v-col>
                 </v-list-item>F ({{ 
               </v-list>
             </v-card>
           </section>
           </VueHtml2pdf> -->
      <v-container
        v-if="!campaignMetaData?.numberOfRounds?.includes('screening') && campaignMetaData?.numberOfRounds?.includes('mains')"
        class="funnel-contianer pl-0 pr-3 mr-0" fluid>
        <div class="w-100 d-flex flex-row">
          <div class="rounded-lg px-0 py-0 pl-1 flex-item-1">
            <v-card class="rounded-lg pr-0 pl-0 cardBorder" width="100%" height="32vh">
              <v-card-title class="pb-2 pl-1 pr-0 pt-1">
                <p class="py-0 my-0 pl-2 funnelText">
                  {{ campaignType == 'TEACHER' ? 'TEACHER' : 'CANDIDATES' }}
                </p>
              </v-card-title>
              <v-card-text class="pt-0  mt-n2 pr-0 pl-0">
                <span class="pl-3 black--text">Registered/Invited</span>
                <FunnelChartCommon :invites="chartData" scaleMax="invited" propertyBegin="invited"
                  propertyEnd="mainsAttempted" funnelColor="#E0ED4B" />
                <div class="d-flex justify-end py-2 pr-2">
                  <img src="../assets/streamline_graph-arrow-decrease.svg" alt="Icon" />
                  <div class="red--text pl-2" style="display: inline-block; margin-bottom: 0">
                    {{
                      calculatePercentage(
                        chartData.invited -
                        chartData.mainsAttempted,
                        chartData.invited
                      )
                    }}%
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </div>
          <div class="rounded-lg px-0 py-0 pl-1 flex-item-1">
            <v-card class="rounded-lg pr-0 pl-0 cardBorder" width="100%" height="32vh">
              <v-card-title class="pb-2 pl-1 pr-0 pt-1">
                <p class="py-0 my-0 pl-2 funnelText">
                  MAINS
                </p>
              </v-card-title>
              <v-card-text class="pt-0  mt-n2 pr-0 pl-0">
                <span class="pl-3 black--text">Attempted</span>
                <FunnelChartCommon :invites="chartData" scaleMax="invited" propertyBegin="mainsAttempted"
                  propertyEnd="mainsPassed" funnelColor="#6AD644" />
                <div class="d-flex justify-end py-2 pr-2">
                  <img src="../assets/streamline_graph-arrow-decrease.svg" alt="Icon" />
                  <div class="red--text pl-2" style="display: inline-block; margin-bottom: 0">
                    {{
                      calculatePercentage(
                        chartData.mainsAttempted -
                        chartData.mainsPassed,
                        chartData.mainsAttempted
                      )
                    }}%
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </div>
          <div class="rounded-lg px-0 py-0 pl-1 flex-item-1">
            <v-card class="rounded-lg pr-0 pl-0 cardBorder" width="100%" height="32vh">
              <v-card-title class="pb-2 pl-1 pr-0 pt-1">
                <p class="py-0 my-0 pl-2 funnelText">
                  MAINS RESULT
                </p>
              </v-card-title>
              <v-card-text class="pt-0  mt-n2 pr-0 pl-0">
                <span class="pl-3 green--text">Passed</span>
                <FunnelChartCommon :invites="chartData" scaleMax="invited" propertyBegin="mainsPassed"
                  propertyEnd="mainsPassed" />
                <!-- <div class="d-flex justify-end py-2 pr-2">
                          <img src="../assets/streamline_graph-arrow-decrease.svg" alt="Icon"/>
                          <div 
                            class="red--text pl-2"
                            style="display: inline-block; margin-bottom: 0">
                            {{
                              calculatePercentage(
                                chartData.mainsPassed -
                                  chartData.demoSubmitted,
                                chartData.mainsPassed
                              )
                            }}%
                          </div>
                          </div> -->
              </v-card-text>
            </v-card>
          </div>
          <!--  <div class="rounded-lg px-0 py-0 pl-1 flex-item-1">
                 <v-card
                   class="rounded-lg pr-0 pl-0 cardBorder"
                   width="100%"
                   height="32vh"
                 >
                   <v-card-title class="pb-2 pl-1 pr-0 pt-1">
                     <p class="py-0 my-0 pl-2 funnelText">
                       DEMO
                     </p>
                   </v-card-title>
                 
                   <v-card-text class="pt-0  mt-n2 pr-0 pl-0">
                     <span class="pl-3 black--text"
                       >Submitted</span
                     >
                     <FunnelChartCommon :invites="chartData" scaleMax="invited" propertyBegin="demoSubmitted" propertyEnd="interviewSubmitted"/>
                     <div class="d-flex justify-end py-2 pr-2">
                       <img src="../assets/streamline_graph-arrow-decrease.svg" alt="Icon"/>
                       <div 
                         class="red--text pl-2"
                         style="display: inline-block; margin-bottom: 0">
                         {{
                           calculatePercentage(
                             chartData.demoSubmitted -
                               chartData.interviewSubmitted,
                             chartData.demoSubmitted
                           )
                         }}%
                       </div>
                     </div>
                   </v-card-text>
                 </v-card>
                 </div> -->
          <div class="rounded-lg px-0 py-0 pl-1 w-19">
            <v-card class="rounded-lg pr-0 pl-0 cardBorder" width="100%" height="32vh">
              <v-card-title class="pr-0 pl-0 pb-0">
                <p class="font-weight-bold pl-1 funnelText">CAMPAIGN SUMMARY</p>
              </v-card-title>
              <v-card outlined class="font-weight-medium pl-1 d-flex align-center rounded mx-3 my-2" width="80%"
                height="40px">
                Candidates Passed : {{ apraisals }}
                <v-spacer></v-spacer>
              </v-card>
            </v-card>
          </div>
        </div>
      </v-container>
      <v-container v-if="campaignMetaData?.numberOfRounds?.includes('screening')" class="funnel-container px-0" fluid>
        <div class="d-flex flex-row" style="align-items: stretch; width: 100%;">
          <div class="card-wrapper d-flex" style="flex:0 0 13%; max-width: 13%;  box-sizing: border-box;">
            <v-card class="rounded-lg cardBorder" style="width: 100%;">
              <v-card-title class="pb-0 pl-1 pr-0 pt-1">
                <p class="funnelText">JOB SEEKERS</p>
              </v-card-title>
              <v-card-text class="pt-0 pr-0 pl-0">
                <span class="pl-3 black--text">Users Invited</span>
                <FunnelChartCommon :invites="chartData" scaleMax="invited" propertyBegin="invited"
                  propertyEnd="screeningStarted" funnelColor="#E0ED4B" />
                <div class="d-flex justify-end pr-2">
                  <img src="../assets/streamline_graph-arrow-decrease.svg" alt="Icon" />
                  <div class="red--text pl-2" style="display: inline-block; margin-bottom: 0">
                    {{
                      calculatePercentage(chartData.invited - chartData.screeningStarted, chartData.invited)
                    }}%
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </div>
          <div class="card-wrapper d-flex"
            style="flex: 0 0 13%; max-width: 13%; padding-left: 8px; box-sizing: border-box;">
            <v-card class="rounded-lg cardBorder" style="width: 100%;">
              <v-card-title class="pb-0 pl-1 pr-0 pt-1">
                <p class="funnelText">SCREENING</p>
              </v-card-title>
              <v-card-text class="pr-0 pl-0 pt-0">
                <span class="pl-3 black--text">Attempted</span>
                <FunnelChartCommon :invites="chartData" scaleMax="invited" propertyBegin="screeningStarted"
                  propertyEnd="screeningPassed" funnelColor="#C3ED4B" />
                <div class="d-flex justify-end pr-2">
                  <img src="../assets/streamline_graph-arrow-decrease.svg" alt="Icon" />
                  <div class="red--text pl-2" style="display: inline-block; margin-bottom: 0">
                    {{
                      calculatePercentage(chartData.screeningStarted - chartData.screeningPassed,
                        chartData.screeningStarted)
                    }}%
                  </div>
                </div>
                <div class="d-flex flex-column fix-ht text-caption pl-2">
                  <p>Not Applicable : {{ screeningSkipped || 0 }}</p>
                  <p>Not Started : {{ isNaN(chartData.invited - chartData.screeningStarted - chartData.screeningSkipped)
                    ?
                    0 : chartData.invited - chartData.screeningStarted - chartData.screeningSkipped }}</p>
                </div>
              </v-card-text>
            </v-card>
          </div>
          <div class="card-wrapper d-flex"
            style="flex: 0 0 13%; max-width: 13%; padding-left: 8px; box-sizing: border-box;">
            <v-card class="rounded-lg cardBorder" style="width: 100%;">
              <v-card-title class="pb-0 pl-1 pr-0 pt-1">
                <p class=" funnelText">SCREENING RESULT</p>
              </v-card-title>
              <v-card-text class="pr-0 pl-0 pt-0">
                <span class="pl-3 green--text">Passed</span>
                <FunnelChartCommon :invites="chartData" scaleMax="invited" propertyBegin="screeningPassed"
                  propertyEnd="mainsStarted" funnelColor="#B0D644" />
                <div class="d-flex justify-end pr-2">
                  <img src="../assets/streamline_graph-arrow-decrease.svg" alt="Icon" />
                  <div class="red--text pl-2" style="display: inline-block; margin-bottom: 0">
                    {{
                      calculatePercentage(chartData.screeningPassed - chartData.mainsStarted, chartData.screeningPassed)
                    }}%
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </div>
          <div class="card-wrapper d-flex"
            style="flex: 0 0 13%; max-width: 13%; padding-left: 8px; box-sizing: border-box;">
            <v-card class="rounded-lg cardBorder" style="width: 100%;">
              <v-card-title class="pb-0 pl-1 pr-0 pt-1">
                <p class="funnelText">MAINS</p>
              </v-card-title>
              <v-card-text class="pr-0 pl-0 pt-0">
                <span class="pl-3 black--text">Attempted</span>
                <FunnelChartCommon :invites="chartData" scaleMax="invited" propertyBegin="mainsStarted"
                  propertyEnd="mainsPassed" funnelColor="#6AD644" />
                <div class="d-flex justify-end  pr-2">
                  <img src="../assets/streamline_graph-arrow-decrease.svg" alt="Icon" />
                  <div class="red--text pl-2" style="display: inline-block; margin-bottom: 0">
                    {{
                      calculatePercentage(chartData.mainsStarted - chartData.mainsPassed, chartData.mainsStarted)
                    }}%
                  </div>
                </div>
                <div class="d-flex flex-column fix-ht text-caption pl-2">
                  <p>Not Applicable : {{ this.mainsSkipped || 0 }}</p>
                  <p>Not Started : {{ isNaN(chartData.invited - chartData.mainsStarted - chartData.mainsSkipped) ? 0 :
                    chartData.invited - chartData.mainsStarted - chartData.mainsSkipped }}</p>
                </div>
              </v-card-text>
            </v-card>
          </div>
          <div class="card-wrapper d-flex"
            style="flex: 0 0 13%; max-width: 13%; padding-left: 8px; box-sizing: border-box;">
            <v-card class="rounded-lg cardBorder" style="width: 100%;">
              <v-card-title class="pb-0 pl-1 pr-0 pt-1">
                <p class="funnelText">MAINS RESULT</p>
              </v-card-title>
              <v-card-text class="pr-0 pl-0 pt-0">
                <span class="pl-3 green--text">Passed</span>
                <FunnelChartCommon :invites="chartData" scaleMax="invited" propertyBegin="mainsPassed"
                  propertyEnd="demoSubmitted" />
                <div class="d-flex justify-end pr-2">
                  <img src="../assets/streamline_graph-arrow-decrease.svg" alt="Icon" />
                  <div class="red--text pl-2" style="display: inline-block; margin-bottom: 0">
                    {{
                      calculatePercentage(chartData.mainsPassed - chartData.demoSubmitted, chartData.mainsPassed)
                    }}%
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </div>
          <div class="card-wrapper d-flex"
            style="flex: 0 0 13%; max-width: 13%; padding-left: 8px; box-sizing: border-box;">
            <v-card class="rounded-lg cardBorder" style="width: 100%;">
              <v-card-title class="pb-0 pl-1 pr-0 pt-1">
                <p class="funnelText">DEMO</p>
              </v-card-title>
              <v-card-text class="pr-0 pl-0 pt-0">
                <span class="pl-3 black--text">Submitted</span>
                <FunnelChartCommon :invites="chartData" scaleMax="invited" propertyEnd="interviewSubmitted"
                  propertyBegin="demoSubmitted" />
                <div class="d-flex justify-end pr-2" style="padding-top: 22px;">
                  <div class="red--text pl-2" style="display: inline-block; margin-bottom: 0">
                  </div>
                </div>
                <div class="d-flex flex-column fix-ht text-caption pl-2">
                  <p>Not Applicable : {{ this.demoSkipped || 0 }}</p>
                </div>
              </v-card-text>
            </v-card>
          </div>
          <div class="summary-column"
            style="flex: 0 0 22%; max-width: 22%; padding-left: 8px; box-sizing: border-box; display: flex; flex-direction: column;">
            <v-card @click="goToJobSeekersAppraisal()" class="cursor rounded-xl col3-card cardBorder" outlined
              color="#4D695B" style="flex: 1 1 0; min-height: 0; margin-bottom: 8px;">
              <v-card-title class="text-subtitle-2">
                <v-row justify="space-between" class="pl-2 white--text">
                  <span class="dashboardCumulativeSection">Recommended for Interview</span>
                  <v-icon color="white">mdi-chevron-right</v-icon>
                </v-row>
              </v-card-title>
              <v-card-subtitle class="px-4 white--text pt-2">
                {{ chartData.demoSubmitted }}
              </v-card-subtitle>
            </v-card>
            <v-card @click="goToJobSeekersInterviewed()" class="cursor rounded-xl col3-card cardBorder" outlined
              color="#FB8C00" style="flex: 1 1 0; min-height: 0; margin-bottom: 8px;">
              <v-card-title class="text-subtitle-2">
                <v-row justify="space-between" class="pl-2 white--text">
                  <span class="dashboardCumulativeSection">Job Seekers Interviewed</span>
                  <v-icon color="white">mdi-chevron-right</v-icon>
                </v-row>
              </v-card-title>
              <v-card-subtitle class="px-4 white--text pt-2">
                {{ chartData.interviewSubmitted }}
              </v-card-subtitle>
            </v-card>
            <v-card @click="goToRecommendedForHiring()" class="cursor rounded-xl col3-card cardBorder" outlined
              color="#00000061" style="flex: 1 1 0; min-height: 0;">
              <v-card-title class="text-subtitle-2">
                <v-row justify="space-between" class="pl-2 white--text">
                  <span class="dashboardCumulativeSection">Recommended for Hiring</span>
                  <v-icon color="white">mdi-chevron-right</v-icon>
                </v-row>
              </v-card-title>
              <v-card-subtitle class="px-4 white--text pt-2">
                {{ recommendedJobseekerCount }}
              </v-card-subtitle>
            </v-card>
          </div>
        </div>
      </v-container>
      <v-row justify="space-between" align="center" class="mb-2">
        <v-col cols="4" sm="4" md="4" class="status-group">
          <v-chip-group v-model="selectedStatus" active-class="active-chip" @change="switchStatusTab" mandatory>
            <v-chip v-for="({ status, count }, index) in statusMap" :key="index" :value="status"
              :outlined="selectedStatus !== status" :disabled="dataTableLoading" elevated>
              {{ `${formatStatus(status)} (${count})` }}
            </v-chip>
          </v-chip-group>
        </v-col>
        <v-col cols="8" sm="8" class="d-flex flex-row justify-end">

          <v-btn v-if="campaignMetaData?.hasInvitationUrl" :loading="qrLoading" @click="generateQRCode" text
            color="#1B72E8">
            <v-img v-bind="attrs" v-on="on" :src="require(`@/assets/component_share.svg`)" />
          </v-btn>
          <v-card width="326px" class="elevation-0 transparent">
            <v-text-field solo label="Search here..." hide-details prepend-inner-icon="mdi-magnify" v-model="search"
              @input="handleSearchInput" class="search-bar border-button rounded-pill ml-4" dense
              clearable></v-text-field>
          </v-card>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="btn outline-btn elevation-0 mx-2 pl-4 pr-6"
                :class="filterCount > 0 ? 'outline-disabled-btn' : ''" rounded depressed v-bind="attrs" v-on="on"
                :disabled="filterCount > 0">
                <v-img v-bind="attrs" v-on="on" :src="require(`@/assets/svg/sort.svg`)" />
                <span>Sort</span>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-for="option in sortOptions" :key="option.value" @click="selectSortOption(option.value)"
                :class="{ 'selected-sort-option': selectedSort === option.value }">
                <v-list-item-title>
                  {{ option.label }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-btn depressed rounded outlined class="btn outline-btn mx-3" @click="filterDialog = true">
            <v-icon>mdi-tune</v-icon>
            <span>
              Filter
              <template v-if="filterCount > 0">({{ filterCount }})</template>
            </span>
          </v-btn>
          <v-btn depressed outlined rounded @click="downlaodCamapignUserDetails"
            class="btn outline-btn elevation-0 mx-3" :loading="downloadLoader">
            <v-icon>mdi-import mdi-rotate-90</v-icon>
          </v-btn>
          <v-btn v-if="!campaignMetaData.hasInvitationUrl" :disabled="selectedUsers.length === 0"
            class="btn primary-btn mx-3 px-4" @click="sendInvitationReminders">
            SEND REMINDER
          </v-btn>
        </v-col>
      </v-row>
      <template>
        <v-card class="hide-scrollbar">
          <v-data-table fixed-header height="calc(100vh - 422px)" :headers="headers" :items="users" item-key="userId"
            :items-per-page="options.itemsPerPage" :page.sync="currentPage" :options.sync="options"
            :loading="dataTableLoading" :show-select="!campaignMetaData.hasInvitationUrl" v-model="selectedUsers"
            :server-items-length="totalUsers" class="elevation-0 custom-data-table"
            :class="isScrollable ? 'frozen-columns-table' : ''" ref="myTable" hide-default-footer>
            <template v-slot:loading>
              <bubble-loader />
            </template>
            <template v-slot:no-data>
              <div class="custom-no-data">
                <p>No Data Available</p>
              </div>
            </template>
            <template v-slot:item.data-table-select="{ item, isSelected, select }">
              <v-simple-checkbox :value="isSelected" :disabled="isRowDisabled(item)" @input="select($event)" />
            </template>
            <template v-slot:header.data-table-select="{ props }">
              <v-simple-checkbox :value="props.value" :indeterminate="props.indeterminate"
                @input="toggleSelectAll($event)" />
            </template>
            <template v-slot:header.stages>
              <v-row class="pl-4">
                <v-col cols="12" class=" reportedText d-flex justify-space-between">
                  <div v-for="(step, index) in stepperStages" :key="index" class="text-center"
                    :class="index == 0 ? 'mr-3' : ''" style="width: 90px">
                    <span>{{ step.label }}</span>
                  </div>
                </v-col>
              </v-row>
            </template>
            <template v-slot:header.league>
              <v-row class="text-center custom-header">
                <v-col class="header-cell">
                  <span class="custom-header-text">League</span>
                </v-col>
              </v-row>
            </template>
            <template v-slot:header.actions>
              <v-row class="text-center custom-header">
                <v-col class="header-cell">
                  <span class="custom-header-text">Action</span>
                </v-col>
              </v-row>
            </template>
            <template v-slot:item.name="{ item }">
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <span class='multi-line-ellipsis' v-bind="attrs" v-on="on">{{ item.personalInfo.firstName |
                    capitalizeFirst}} {{ item.personalInfo.lastName | capitalizeFirst }}</span>

                </template>
                <span>
                  {{ item.personalInfo.firstName | capitalizeFirst }}
                  {{ item.personalInfo.lastName | capitalizeFirst }}
                </span>
              </v-tooltip>
            </template>
            <template v-slot:item.email="{ item }">

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span
                    :class='campaignMetaData?.isExternalClient ? "widened-multi-line-ellipsis" : "multi-line-ellipsis"'
                    class="cursor" v-bind="attrs" v-on="on" @click="copyEmailId(item.personalInfo.contactInfo.email)">{{
                      item.personalInfo.contactInfo.email }}</span>
                </template>
                <span> {{ item.personalInfo.contactInfo.email }}</span>
              </v-tooltip>
            </template>
            <template v-slot:item.levels="{ item }">
              <div>
                {{ getLevelAlias(item.teachingInterests?.levels) }}
              </div>
            </template>
            <template v-slot:item.score="{ item }">
              <div>
                {{ `${item.mainsTotal} / ${item.maximumMarks || 10}` }}
              </div>
            </template>
            <template v-slot:item.location="{ item }">
              <div class="my-custom-tooltip">
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">{{ item.modifiedLocation.displayValue }}</span>
                  </template>
                  <span :class="item.modifiedLocation.displayValue.includes('+') ? 'custom-tooltip' : ''"
                    v-for="location in item.modifiedLocation.tooltipValue.split(',')">{{ location }}</span>
                </v-tooltip>
              </div>

            </template>
            <template v-slot:item.jobrole="{ item }">
              <div class="my-custom-tooltip">
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">{{ item.modifiedJobRoles.displayValue }}</span>
                  </template>

                  <span :class="item.modifiedJobRoles.displayValue.includes('+') ? 'custom-tooltip' : ''"
                    v-for="job in item.modifiedJobRoles.tooltipValue.split(',')">{{ job }}</span>
                </v-tooltip>
              </div>

            </template>
            <template v-slot:item.stages="{ item, index }">
              <v-row class="d-flex flex-row align-center pl-15 pr-8">
                <!-- <v-col cols="12" v-if="['MESTA_STUDENTS', 'JOB_SEEKER', 'NTP'].includes(campaignType)"> -->
                <v-col cols="12"
                  v-if="campaignMetaData?.numberOfRounds?.includes('screening') || (campaignMetaData?.isExternalClient === true && campaignMetaData?.assessmentType?.toLowerCase() === 'dynamic')">

                  <v-row class="d-flex flex-row align-center">
                    <v-icon medium :color="stepper.get(index).invitation?.iconColor">{{
                      stepper.get(index).invitation?.name }}</v-icon>
                    <!-- <template v-if="['MESTA_STUDENTS', 'JOB_SEEKER'].includes(campaignType)"> -->
                    <template v-if="campaignMetaData?.numberOfRounds?.includes('screening')">
                      <v-divider :thickness="10" class="border-opacity-25 px-0 py-0"
                        :color="stepper.get(index).screening?.iconColor"></v-divider>
                      <!-- <v-icon
                                   v-if="['MESTA_STUDENTS', 'JOB_SEEKER'].includes(campaignType) && stepper.get(index).screening?.stepType == 'showStepperIcon'"
                                   medium
                                   :color="stepper.get(index).screening?.iconColor"
                                   > -->
                      <v-icon
                        v-if="campaignMetaData?.numberOfRounds?.includes('screening') && stepper.get(index).screening?.stepType == 'showStepperIcon'"
                        medium :color="stepper.get(index).screening?.iconColor">{{ stepper.get(index).screening?.name
                        }}</v-icon>
                      <span class="text-body-2 text-color"
                        v-if="campaignMetaData?.numberOfRounds?.includes('screening') && stepper.get(index).screening?.stepType == 'showSkippedIcon'">
                        NA</span>
                      <!-- <div style="height: 24px" v-if="['MESTA_STUDENTS', 'JOB_SEEKER'].includes(campaignType) && stepper.get(index).screening?.stepType == 'showActionIcon' "> -->
                      <div style="height: 24px"
                        v-if="campaignMetaData?.numberOfRounds?.includes('screening') && stepper.get(index).screening?.stepType == 'showActionIcon'">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-img v-bind="attrs" v-on="on" class="stepper-icon"
                              :src="require(`@/assets/svg/${stepper.get(index).screening?.iconName}`)" alt="" />
                          </template>
                          <div v-if="users[index].status === 'CLOSED'">
                            <p>Application closed</p>
                          </div>
                          <div v-else-if="users[index].isScreeningQuit">
                            <p>Application Quit</p>
                          </div>

                          <div v-else-if="users[index].isHREvaluate">
                            <p>Waiting for HR Evaluation</p>
                            <p>candidate is waiting for HR team to evaluate application and get back.</p>
                          </div>
                          <div v-else-if="users[index].isTakeLater">
                            <p>Candidate will take test later</p>
                            <p>An email is sent to candidate with test link.</p>
                          </div>

                        </v-tooltip>
                      </div>
                      <!-- <span  :class="getStepperClasses(index, 'screening')"  v-if="['MESTA_STUDENTS', 'JOB_SEEKER'].includes(campaignType) && stepper.get(index).screening?.stepType == 'showMarks'"> {{ stepper.get(index).screening.marks }}/10</span> -->
                      <span :class="getStepperClasses(index, 'screening')"
                        v-if="campaignMetaData?.numberOfRounds?.includes('screening') && stepper.get(index).screening?.stepType == 'showMarks'">
                        {{ `${stepper.get(index).screening.marks}/${item?.maximumMarks || 10}` }}</span>
                    </template>
                    <v-divider :thickness="2" class="border-opacity-87 px-0 py-0"
                      :color="stepper.get(index).mains?.iconColor"></v-divider>
                    <!-- <v-icon v-if="['TEACHER'].includes(campaignType)" medium :color="stepper.get(index).mains?.iconColor"> -->
                    <v-icon
                      v-if="!campaignMetaData?.numberOfRounds?.includes('screening') && campaignMetaData?.isExternalClient === false"
                      medium :color="stepper.get(index).mains?.iconColor">
                      {{ stepper.get(index).mains?.name }}</v-icon>
                    <!-- <v-icon
                                v-if="['MESTA_STUDENTS', 'JOB_SEEKER', 'NTP'].includes(campaignType) && stepper.get(index).mains?.stepType == 'showStepperIcon'"
                                medium
                                :color="stepper.get(index).mains?.iconColor"
                                > -->
                    <v-icon
                      v-if="(campaignMetaData?.numberOfRounds?.includes('screening') || (campaignMetaData?.isExternalClient === true && campaignMetaData?.assessmentType?.toLowerCase() === 'dynamic')) && stepper.get(index).mains?.stepType == 'showStepperIcon'"
                      medium :color="stepper.get(index).mains?.iconColor">
                      {{ stepper.get(index).mains?.name }}</v-icon>
                    <!-- <span  :class="getStepperClasses(index, 'mains')"  v-if="['MESTA_STUDENTS', 'JOB_SEEKER', 'NTP'].includes(campaignType) && stepper.get(index).mains?.stepType == 'showMarks' "> {{ stepper.get(index).mains.marks }}/10</span> -->
                    <!-- <div style="height: 24px" v-if="['MESTA_STUDENTS', 'JOB_SEEKER',  'NTP'].includes(campaignType)  && stepper.get(index).mains?.stepType == 'showActionIcon'"> -->
                    <span :class="getStepperClasses(index, 'mains')"
                      v-if="(campaignMetaData?.numberOfRounds?.includes('screening') || (campaignMetaData?.isExternalClient === true && campaignMetaData?.assessmentType?.toLowerCase() === 'dynamic')) && stepper.get(index).mains?.stepType == 'showMarks'">
                      {{ `${stepper.get(index).mains.marks}/${item?.maximumMarks || 10}` }}</span>
                    <span class="text-body-2 text-color"
                      v-if="campaignMetaData?.numberOfRounds?.includes('screening') && stepper.get(index).mains?.stepType == 'showSkippedIcon'">
                      NA</span>
                    <div style="height: 24px"
                      v-if="(campaignMetaData?.numberOfRounds?.includes('screening') || (campaignMetaData?.isExternalClient === true && campaignMetaData?.assessmentType?.toLowerCase() === 'dynamic')) && stepper.get(index).mains?.stepType == 'showActionIcon'">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-img v-bind="attrs" v-on="on" class="stepper-icon"
                            :src="require(`@/assets/svg/${stepper.get(index).mains?.iconName}`)" alt="" />
                        </template>
                        <div v-if="users[index].status === 'CLOSED'">
                          <p>Application closed</p>
                        </div>
                        <div v-else-if="users[index].isMainsQuit">
                          <p>Application Quit</p>
                        </div>
                        <div v-else-if="users[index].isHREvaluate">
                          <p>Waiting for HR Evaluation</p>
                          <p>candidate is waiting for HR team to evaluate application and get back.</p>
                        </div>
                        <div v-else-if="users[index].isTakeLater">
                          <p>Candidate will take test later</p>
                          <p>An email is sent to candidate with test link.</p>
                        </div>

                      </v-tooltip>
                    </div>
                    <!-- <v-divider v-if="['MESTA_STUDENTS', 'JOB_SEEKER'].includes(campaignType)"
                                :thickness="10"
                                class="border-opacity-25 px-0 py-0"
                                :color="stepper.get(index).demo?.iconColor"
                                ></v-divider> -->
                    <v-divider v-if="campaignMetaData?.numberOfRounds?.includes('screening')" :thickness="10"
                      class="border-opacity-25 px-0 py-0" :color="stepper.get(index).demo?.iconColor"></v-divider>
                    <v-icon
                      v-if="campaignMetaData?.numberOfRounds?.includes('screening') && stepper.get(index).demo?.stepType == 'showStepperIcon'"
                      medium :color="stepper.get(index).demo?.iconColor">{{ stepper.get(index).demo?.name }}</v-icon>
                    <span :class="getStepperClasses(index, 'demo')"
                      v-if="campaignMetaData?.numberOfRounds?.includes('screening') && stepper.get(index).demo?.stepType === 'showMarks'">
                      {{ stepper.get(index).demo.marks !== undefined && stepper.get(index).demo.marks !== null ?
                        stepper.get(index).demo.marks + '/10' : stepper.get(index).demo.marks }}
                    </span>
                    <span class="text-body-2 text-color"
                      v-if="campaignMetaData?.numberOfRounds?.includes('screening') && stepper.get(index).demo?.stepType == 'showSkippedIcon'">
                      NA</span>
                    <div style="height: 24px"
                      v-if="campaignMetaData?.numberOfRounds?.includes('screening') && stepper.get(index).demo?.stepType == 'showActionIcon'">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-img v-bind="attrs" v-on="on" class="stepper-icon"
                            :src="require(`@/assets/svg/${stepper.get(index).demo?.iconName}`)" alt="" />
                        </template>
                        <div v-if="users[index].isHREvaluate">
                          <p>Waiting for HR Evaluation</p>
                          <p>candidate is waiting for HR team to evaluate application and get back.</p>
                        </div>
                        <div v-if="users[index].isTakeLater">
                          <p>Candidate will take test later</p>
                          <p>An email is sent to candidate with test link.</p>
                        </div>
                        <div v-if="users[index].status === 'CLOSED'">
                          <p>Application closed</p>
                        </div>
                      </v-tooltip>
                    </div>
                    <v-divider v-if="campaignMetaData?.numberOfRounds?.includes('screening')" :thickness="10"
                      class="border-opacity-25 px-0 py-0" :color="stepper.get(index).interview?.iconColor"></v-divider>
                    <v-icon
                      v-if="campaignMetaData?.numberOfRounds?.includes('screening') && stepper.get(index).interview?.stepType == 'showStepperIcon'"
                      medium class="pr-4" :color="stepper.get(index).interview?.iconColor">{{
                        stepper.get(index).interview?.name }}</v-icon>
                    <span :class="getStepperClasses(index, 'interview')"
                      v-if="campaignMetaData?.numberOfRounds?.includes('screening') && stepper.get(index).interview?.stepType == 'showMarks'">
                      {{ stepper.get(index).interview.marks }}/10</span>
                    <span class="text-body-2 text-color"
                      v-if="campaignMetaData?.numberOfRounds?.includes('screening') && stepper.get(index).interview?.stepType == 'showSkippedIcon'">
                      NA</span>
                    <div style="height: 24px"
                      v-if="campaignMetaData?.numberOfRounds?.includes('screening') && stepper.get(index).interview?.stepType == 'showActionIcon'">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-img v-bind="attrs" v-on="on" class="stepper-icon"
                            :src="require(`@/assets/svg/${stepper.get(index).interview?.iconName}`)" alt="" />
                        </template>
                        <div v-if="users[index].isHREvaluate">
                          <p>Waiting for HR Evaluation</p>
                          <p>candidate is waiting for HR team to evaluate application and get back.</p>
                        </div>
                        <div v-if="users[index].isTakeLater">
                          <p>Candidate will take test later</p>
                          <p>An email is sent to candidate with test link.</p>
                        </div>
                        <div v-if="users[index].status === 'CLOSED'">
                          <p>Application closed</p>
                        </div>
                      </v-tooltip>
                    </div>
                  </v-row>
                </v-col>
                <v-col v-else>
                  <v-row class="d-flex flex-row align-center">
                    <v-icon medium :color="stepper.get(index).invitation?.iconColor">{{
                      stepper.get(index).invitation?.name }}</v-icon>
                    <v-divider :thickness="2" class="border-opacity-87 px-0 py-0"
                      :color="stepper.get(index).mains?.iconColor">
                    </v-divider>
                    <v-icon
                      v-if="campaignMetaData?.assessmentType?.toLowerCase() === 'dynamic' && stepper.get(index).mains?.stepType == 'showStepperIcon'"
                      medium :color="stepper.get(index).mains?.iconColor">
                      {{ stepper.get(index).mains?.name }}
                    </v-icon>
                    <span :class="getStepperClasses(index, 'mains')"
                      v-if="campaignMetaData?.assessmentType?.toLowerCase() === 'dynamic' && stepper.get(index).mains?.stepType == 'showMarks'">
                      {{ `${stepper.get(index).mains.marks}/${item?.maximumMarks || 10}` }}
                    </span>
                  </v-row>
                </v-col>
              </v-row>
            </template>
            <template v-slot:item.status="{ item }">
              <v-chip :class="getStatusClass(item).class">
                {{ getStatusClass(item).statusName }}
              </v-chip>
            </template>
            <template v-slot:item.league="{ item }">
              <div v-if="item.coreSkillsSubject != undefined && item.coreSkillsSubject.length > 0"
                class="text-subtitle-1 d-flex justify-center">
                <div v-if="!item.NoLeague" class="d-flex  justify-space-around pt-4">
                  <div v-for="(coreSkill, index) in item.coreSkillsSubject.slice(0, 3)" :key="index" class="w-fit">
                    <v-tooltip v-if="coreSkill.league != 'Not Eligible'" top>
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on" class="d-flex flex-column align-center mx-2">
                          <img v-if="coreSkill.league == 'Gold'" height="23px" width="25" src="./../assets/gold.svg" />
                          <img v-if="coreSkill.league == 'Silver'" height="23px" width="25"
                            src="./../assets/silver.svg" />
                          <img v-if="coreSkill.league == 'Bronze' ||
                            coreSkill.league == 'Bonze'" height="23px" width="25"
                            src="./../assets/bronze.svg" />
                          <div style="font-size: 12px">
                            <span v-if="coreSkill.rank !== undefined">#{{ coreSkill.rank }}</span>
                          </div>
                        </div>
                      </template>
                      <span style="font-size: 15px">{{ coreSkill.skillName }} -
                        {{ coreSkill?.percentile?.toFixed(2) || '' }}%
                      </span>
                    </v-tooltip>
                  </div>
                  <v-btn v-if="item.coreSkillsSubject.length > 3" :loading="btnLoading" @click="
                    openLeagueDialog(
                      item.coreSkillsSubject,
                      item.personalInfo.firstName,
                      item.personalInfo.lastName
                    )
                    " height="10px" width="10px" text color="#1B72E8" class="text-body-2 ml-9">View
                    More</v-btn>
                </div>
                <div v-else class="d-flex justify-center mt-1">
                  -
                </div>
              </div>
              <div v-else class="d-flex justify-center mt-1">
                -
              </div>
            </template>
            <template v-slot:item.actions="{ item, index }">
              <div class="d-flex justify-center">
                <v-menu left bottom offset-x offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="content-black-badge action-btn-wrapper" icon v-bind="attrs" v-on="on">
                      <v-badge v-if="item.filters?.latestStatus === 'ROUND_ACCEPTED'" color="#E697AB"
                        :content="item.round" location="bottom end" offset-y="10" offset-x="7">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-badge>
                      <v-icon v-else>mdi-dots-vertical</v-icon>
                      <span v-if="item.showNotificationBadge || item.showFeedbackNotificationBadge" class="notification-dot dot-position-3"></span>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item v-if="!campaignMetaData?.isExternalClient" @click="selectUser(item)">
                      <v-list-item-title>View Candidate</v-list-item-title>
                    </v-list-item>
                    <v-list-item :disabled="!isTestReportEnabled(index, item.userType, item.currentTestRoundIndex)"
                      @click="getResult(item)">
                      <v-list-item-title>Test Report</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="!campaignMetaData?.isExternalClient"
                      @click="$router.push({ path: '/user-history', query: { userId: item.userId, campaignId: $route.query.id } })">
                      <v-list-item-title>View Candidate History</v-list-item-title>
                    </v-list-item>
                    <v-menu v-if="!campaignMetaData?.isExternalClient" offset-x offset-y bottom left open-on-hover
                      close-delay="300">
                      <template v-slot:activator="{ on, attrs }">
                        <v-list-item v-if="item.userType !== 'Teacher'"
                          :disabled="(!canScheduleInterview(item) && item.userType !== 'Teacher') || item.status == 'CLOSED'"
                          v-bind="attrs" v-on="on" class="d-flex align-center justify-space-between">
                          <div class="d-flex align-center flex-1 action-btn-wrapper">
                            <v-badge v-if="item.filters?.latestStatus === 'ROUND_ACCEPTED'" color="#E697AB" dot
                              offset-x="1" offset-y="1">
                              <span class="mr-2">Interview</span>
                            </v-badge>
                            <span v-else class="mr-2">Interview</span>
                          </div>
                          <span v-if="item.showNotificationBadge" class="notification-dot dot-position-4"></span>
                          <v-icon style="font-size: 24px !important;">mdi-chevron-double-right</v-icon>
                        </v-list-item>
                      </template>
                      <v-list v-if="!campaignMetaData?.isExternalClient">
                        <v-list-item
                          @click="gotoScheduleInterview(item, '', (!item?.interviewDetails || item.filters?.latestStatus === 'ROUND_ACCEPTED'))"
                          :disabled="isInterviewFeedbackComplete(item) || isInterviewInProgress(item)">
                          <v-list-item-title v-if="!item?.interviewDetails">
                            Schedule Interview
                          </v-list-item-title>
                          <v-list-item-title v-else-if="item.filters?.latestStatus === 'ROUND_ACCEPTED'">
                            <v-badge color="#E697AB" dot offset-x="9" offset-y="-3">
                              <span>Schedule New Round ({{ Number(item.round) + 1 }})</span>
                            </v-badge>
                          </v-list-item-title>
                          <v-list-item-title v-else class="action-btn-wrapper">

                            Edit interview
                            <span v-if="item.showNotificationBadge" class="notification-dot dot-position-5"></span>

                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item :disabled="!hasCurrentRoundFeedback(item)" @click="openFeedbackDialog(item)">
                          <v-list-item-title class="action-btn-wrapper">
                            View Feedback
                            <span v-if="item.showFeedbackNotificationBadge" class="notification-dot dot-position-6"></span>
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <v-list-item v-if="!campaignMetaData?.isExternalClient" :disabled="isInterviewHistory(item)"
                      @click="handleInterviewHistoryClick(item)">
                      <v-list-item-title>View Interview History</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="!campaignMetaData?.isExternalClient"
                      :disabled="!(item.userType.toLowerCase() !== 'teacher' && isUserReportEnabled(index, item.userType))"
                      @click="getFinalResult(item.userId)">
                      <v-list-item-title>User Dashboard</v-list-item-title>
                    </v-list-item>
                    <v-list-item :disabled="!canRestartExam(item.campaignStatus, item)"
                      @click="handleRestartClick(item)">
                      <v-list-item-title>Restart Test</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-if="item.userType.toLowerCase() !== 'teacher' && item.isHREvaluate && !item.demoStatus && !campaignMetaData?.isExternalClient"
                      @click="confirmHrEvaluation({
                        fName: item.personalInfo?.firstName,
                        lName: item.personalInfo?.lastName,
                        email: item.personalInfo.contactInfo?.email,
                        jobRole: item.teachingInterests.jobRole.HRIS_unique_role,
                        userId: item.userId,
                        stage: getHrEvaluationStage(stepper.get(index)),
                        deviceType: item.deviceType,
                      })">
                      <v-list-item-title>Initiate Next Round</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="!campaignMetaData?.isExternalClient"
                      :disabled="disableCloseApplicationOption(item)" @click="openCloseApplicationDialog(item)">
                      Close Application
                    </v-list-item>
                    <v-list-item v-if="!campaignMetaData.hasInvitationUrl" :disabled="item?.campaignStatus.length > 1"
                      @click="addUserToRemindList(item)">
                      Send Invitation Reminder
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </template>
            <template v-slot:item.proficiencyLevel="{ item }">
              {{ item.proficiencyLevel | capitalizeFirst }}
            </template>
            <template v-slot:footer="{ props }">
              <table-footer :pagination="props.pagination" :options="props.options" @update-options="onFooterUpdate" />
            </template>
          </v-data-table>
          <UserProfile :user="selectedUser" @close="selectedUser = null" />
        </v-card>
      </template>
      <v-dialog v-model="errorDialog" class="cdz" max-width="366px" persistent>
        <v-card>
          <v-container fluid class="pa-8">
            <v-card-text class="text-center">
              <v-icon color="error" size="96">mdi-close-circle-outline</v-icon>
              <p class="text-h5 pt-2 font-weight-medium">Error</p>
              <p class="text-h6 py-3 font-weight-regular">{{ errorMessage }}</p>
              <div class="d-flex justify-center">
                <v-btn class="primary-btn btn" large width="157px" rounded @click="errorDialog = false">Ok</v-btn>
              </div>
            </v-card-text>
          </v-container>
        </v-card>
      </v-dialog>
      <v-dialog v-model="successDialog" class="cdz" max-width="366px" persistent>
        <v-card>
          <v-container fluid class="pa-8">
            <v-card-text class="text-center">
              <v-icon color="#228B22" size="96">mdi-check-circle-outline</v-icon>
              <p class="text-h5 py-4">Cluster</p>
              <div class="d-flex justify-center">
                <v-btn class="primary-btn btn" large width="157px" rounded @click="successDialog = false">Ok</v-btn>
              </div>
            </v-card-text>
          </v-container>
        </v-card>
      </v-dialog>
    </div>
    <v-snackbar v-model="snackbar" :timeout="1000">
      Link Copied
    </v-snackbar>
    <v-snackbar v-model="emailSnackbar" :timeout="1000">
      Email Id Copied
    </v-snackbar>
    <v-snackbar v-model="clearUserAssessmentSuccessSnackbar" :timeout="1000">
      Success
    </v-snackbar>
    <v-snackbar v-model="clearUserAssessmentFailureSnackbar" :timeout="1000">
      Application error encountered
    </v-snackbar>
    <v-snackbar v-model="HrEvaluationMailSnackBar" :timeout="1000">
      Mail Sent to the user
    </v-snackbar>
    <v-snackbar v-model="assessmentReminderSnackBar" :timeout="1000">
      Assessment reminder {{ selectedUsers.length > 1 ? 'mails' : 'mail' }} sent
    </v-snackbar>
  </div>
</template>

<script>
import FunnelChart from "./FunnelChart.vue";
import CampaignController from "@/controllers/CampaignController";
import UsersController from "@/controllers/UsersController";
import AuthService from "../services/AuthService";
import Notification from "./Notification";
import { mapActions } from 'vuex';
import {
  collection,
  getDocs,
  onSnapshot,
  doc,
  getDoc,
  where,
  query
} from "firebase/firestore";
import { db, app } from "../firebase";
import ClusterController from "@/controllers/ClusterController";
import BoardController from "@/controllers/BoardController";
import { GChart } from "vue-google-charts/legacy";
import FunnelChart1 from "./FunnelChart1.vue";
import FunnelChart2 from "./FunnelChart2.vue";
import FunnelChart3 from "./FunnelChart3.vue";
import FunnelChart4 from "./FunnelChart4.vue";
import FunnelChart5 from "./FunnelChart5.vue";
import FunnelChart6 from "./FunnelChart6.vue";
import FunnelChart7 from "./FunnelChart7.vue";
import FunnelChart8 from "./FunnelChart8.vue";
import FunnelChart9 from "./FunnelChart9.vue";
import axios from "axios";

import VueQRCodeComponent from "vue-qrcode-component";
import html2canvas from "html2canvas";
import Papa from "papaparse";
import FunnelChartCommon from "./FunnelChartCommon.vue";
import { filter } from "jszip";
import { debounce } from 'lodash';
import { format, startOfToday, startOfYesterday, startOfWeek, startOfMonth, startOfLastWeek, startOfLastMonth, endOfToday, endOfYesterday, endOfWeek, endOfMonth, endOfLastWeek, endOfLastMonth } from 'date-fns';
import MailController from "../controllers/mailController";
import { liveListenerUnsubscriber } from "@/mixins/liveListenerUnsubcriber";
import BubbleLoader from "@/components/BubbleLoader.vue";
import SchoolController from "@/controllers/SchoolController";
import LeagueController from "@/controllers/LeagueController";
import AudienceRolesController from "@/controllers/AudienceRolesController";
import LevelController from "@/controllers/LevelController";
import SubjectController from "@/controllers/SubjectController";
import UserNavMenu from "@/components/UserNavMenu.vue";
import UserProfile from '@/components/UserProfile.vue';
import FilterSearch from '@/components/FilterSearch.vue';
import InterviewConstants from '@/controllers/constants/InterviewStatus'
import isTableScrollableMixin from "@/mixins/isTableScrollableMixin";
import InterviewFeedbackDialog from "@/components/InterviewFeedbackDialog.vue";

export default {
  name: "CampaignUserView",
  components: {
    // TimeChart,
    // PieChart,
    // VueHtml2pdf,
    Notification,
    // DemoReport,
    FunnelChart,
    GChart,
    FunnelChart1,
    FunnelChart2,
    FunnelChart3,
    FunnelChart4,
    FunnelChart5,
    FunnelChart6,
    FunnelChart7,
    FunnelChart8,
    FunnelChart9,
    FunnelChartCommon,
    VueQRCodeComponent,
    BubbleLoader,
    UserNavMenu,
    UserProfile,
    FilterSearch,
    InterviewConstants,
    InterviewFeedbackDialog
  },
  mixins: [liveListenerUnsubscriber, isTableScrollableMixin],
  data() {
    return {
      pendingCurrentRoundfeedback: [],
      viewFeedbackDialog: false,
      currentRoundFeedback: [],
      truncatedComments: {},
      feedbackItem: null,
      selectedRound: 1,
      feedbackRounds: [],
      interviewFeedbackDetailDialog: false,
      detailFeedbackLoading: false,
      detailFeedbackPersonalInfo: null,
      detailFeedbackInterviewDetails: null,
      detailFeedbackProctoringPic: null,
      detailFeedbackList: [],
      detailFeedbackInterviewerEmail: '',
      detailFeedbackRound: 1,
      currentPage: 1,
      sortCol: "",
      sortOrder: "",
      options: { page: 1, itemsPerPage: 10 },
      restartAssessmentLoader: false,
      restartAssessmentDialog: false,
      userForClearAssessment: "",
      progressLevel: 0,
      userTime: 0,
      maxTime: 0,
      maxMarks: 0,
      campName: "",
      audienceId: null,
      isHrAction: false,
      // dataDemoVideos: [],
      notificationDialog: false,
      appliedFilter: false,
      scheduleInterviewDialog: false,
      pageSize: 10,
      snackbar: false,
      totalUsers: 0,
      page: 1,
      isSelect: 0,
      count: 0,
      errorDialog: false,
      successDialog: false,
      errorMessage: "",
      singleSelect: false,
      dLoading: false,
      loading: false,
      selected: [],
      clusters: [],
      attrs: "",
      on: "",
      currentUserDataForScheduleInterview: {},
      downloadLoader: false,
      btnLoading: false,
      search: "",
      selectedClusterFilters: [],
      selectedBoardsFilter: [],
      selectedLocationFilters: [],
      selectedJobRolesFilters: [],
      selectedDateFilters: null,
      sendSelectedDateFilter: null,
      selectedLeagueFilters: [],
      selectedDemoFilters: [],
      selectedMainsFilters: [],
      selectedScreeningFilters: [],
      selectedInterviewsFilters: [],
      selectedRankFilters: null,
      selectedLevelFilters: [],
      selectedSubjectFilters: [],
      selectedSchoolCitiesFilter: [],
      selectedDepartmentFilter: [],
      selectedGroupFilter: [],
      selectedSourceFilter: [],
      selectedCandidateDecisionFilter: [],
      candidateDecisionFilter: {
        onboarding: [],
        quickfitment: [],
        detailfitment: [],
      },
      selectedOnBoardingDecisionFilter: [],
      selectedAfterScreeningDecisionFilter: [],
      selectedAfterMainsDecisionFilter: [],
      selectedCandidateDecisionStatusFilter: [],
      filterDialog: false,
      filterCount: 0,
      id: "",
      funnelUnsubscribe: null,
      uniqueArray: [],
      skillsList: [],
      power: 80,
      campaignName: "",
      users: [],
      selectedUsers: [],
      preSearchUser: [],
      questions: [],
      totalScore: 0,
      boardsData: [],
      jobRolesData: [],
      levelData: [],
      rankData: [{
        name: "Top 10",
        value: {
          order: "asc",
          limit: 10,
        }
      }, {
        name: "Top 50",
        value: {
          order: "asc",
          limit: 50,
        }
      }, {
        name: "Top 100",
        value: {
          order: "asc",
          limit: 100,
        }
      }, {
        name: "Top 200",
        value: {
          order: "asc",
          limit: 200,
        }
      }],
      subjectData: [],
      screeningData: [{
        name: "In Progress",
        value: "SCREENING STARTED"
      }, {
        name: "Pass",
        value: "SCREENING PASSED"
      },
      {
        name: "Fail",
        value: "SCREENING FAILED"
      }],
      mainsData: [
        {
          name: "In Progress",
          value: "MAINS STARTED"
        }, {
          name: "Pass",
          value: "MAINS PASSED"
        },
        {
          name: "Fail",
          value: "MAINS FAILED"
        }
      ],
      statusData: [
        {
          name: "Yet To Start",
          value: "INVITED"
        },
        {
          name: "In Progress",
          value: "MAINS STARTED"
        },
        {
          name: "Completed",
          value: ["MAINS PASSED", "MAINS FAILED"]
        },
        {
          name: "Quit",
          value: "MAINS QUIT"
        }
      ],
      interviewsData: [
        {
          name: "Scheduled",
          value: "INTERVIEW SCHEDULED",
        },
        {
          name: "Rescheduled",
          value: "INTERVIEW RESCHEDULED",
        },
        {
          name: "Interview Completed",
          value: "INTERVIEW COMPLETED",
        },
        {
          name: "Accepted",
          value: "ACCEPT"
        }, {
          name: "Rejected",
          value: "REJECT"
        }, {
          name: "On Hold",
          value: "ONHOLD"
        }, {
          name: "Round Accepted",
          value: "ROUND_ACCEPTED",
        }
        , {
          name: "Send to Hiring Manager",
          value: "SEND_TO_HIRING_MANAGER",
        }
      ],
      demoData: [
        {
          name: "Yes",
          value: "DEMO SUBMITTED"
        }, {
          name: "No",
          value: ["MAINS FAILED", "MAINS PASSED"]
        },
      ],
      dateData: [{
        name: "Today",
        value: "today",
      }, {
        name: "Yesterday",
        value: "yesterday",
      }, {
        name: "This week",
        value: "this_week",
      }, {
        name: "Last week",
        value: "last_week",
      }, {
        name: "This month",
        value: "this_month",
      }, {
        name: "Last month",
        value: "last_month",
      }],
      locationData: [],
      ranData: [],
      leagueData: [],
      departmentData: [],
      groupData: [],
      schoolCitiesData: [],
      sourceData: [],
      decisionData: [{
        text: "Now",
        value: "Now"
      }, {
        text: "Take Later",
        value: "TakeLater"
      }, {
        text: "Wait for HR",
        value: "HREvaluate"
      }],

      currenrSkillIndex: 0,
      reportDialog: false,
      demoDialog: false,
      color: "white",
      selectedSkill: {},
      userName: "",
      selectedResult: {},
      isFilterLoading: false,
      resultData: [],
      searchBool: false,
      coreSkillsList: [],
      preloader: false,
      dataTableLoading: true,
      isResudule: false,
      headers: [
        { text: 'Name', value: 'name', sortable: false, cellClass: 'text-no-wrap', width: '20%' },
        { text: 'Email ID', value: 'email', sortable: false, cellClass: "text-lowercase text-no-wrap", width: '20%' },
        { text: 'Stages', value: 'stages', sortable: false },
        { text: 'Action', value: 'actions', sortable: false, width: '10%' },
      ],
      tableData: [],
      slotStatus: '',
      invited: 0,
      screeningStarted: 0,
      screeningPassed: 0,
      screeningSkipped: 0,
      screeningFailed: 0,
      mainsStarted: 0,
      mainsSkipped: 0,
      demoSkipped: 0,
      leagueDialog: false,
      mainsPassed: 0,
      mainsFailed: 0,
      apraisals: 0,
      pip: 0,
      tbd: 0,
      chartData: {
        invited: 0,
        screeningStarted: 0,
        screeningPassed: 0,
        screeningFailed: 0,
        mainsStarted: 0,
        mainsPassed: 0,
        mainsFailed: 0,
        demoSubmitted: 0,
        interviewSubmitted: 0,
        apraisals: 0,
        pip: 0,
        tbd: 0,
        procBarColor: "#000",
      },
      selectedUser: null,
      proctorDialog: false,
      selectedUserName: "",
      stepper: new Map(),
      csvData: [],
      campaignDetails: {},
      recommendedJobseekerCount: 0,
      campaignType: '',
      selectedSort: '',
      menu: false,
      menuStart: false,
      menuEnd: false,
      customStartDate: new Date().toISOString().substring(0, 10),
      customEndDate: new Date().toISOString().substring(0, 10),
      isCustom: false,
      roleCluster: "",
      roleSchool: "",
      sortOptions: [
        { value: "nameAsc", label: "Name - Ascending (A-Z)" },
        { value: "nameDesc", label: "Name - Descending (Z-A)" },
        { value: "dateNewest", label: "Date - Newest" },
        { value: "dateOldest", label: "Date - Oldest" },
      ],
      interviewAcceptedRoundsFilter: [],
      interviewRejectedRoundsFilter: [],
      selectedInterviewsFiltersWithRounds: [],

      // bubbleChartOptions: {
      //   title: "",

      //   hAxis: {
      //     title: 'Time (min)', format: 0, viewWindow: {
      //       min: 0,
      //       max: 10
      //     }
      //   },
      //   vAxis: {
      //     title: 'Ques', format: 0, viewWindow: {
      //       min: 0,
      //       max: 10
      //     }
      //   },

      //   sizeAxis: {
      //     minSize: 5,
      //     maxSize: 5
      //   },

      //   // legend: 'none',
      // },

      // bubbleChartData: [
      //   ["Id", "Time (min)", "Ques", "Activity", "Time Stamp"],
      // ],

      // barChartData: this.cumulativeProctoringData,

      // barChartOptions: {
      //   title: '',
      //   titleTextStyle: {
      //     fontSize: 12
      //   },
      //   hAxis: {
      //     title: 'Count',
      //     format: 0,
      //     gridlines: {
      //       color: 'transparent'
      //     },
      //     viewWindow: {
      //       min: 0,
      //     },
      //   },
      //   vAxis: {
      //     title: 'Activity',
      //   },
      //   legend: 'none'
      // },

      // userName: "",
      snackbar: false,
      qrLoading: false,
      qrCampaignLink: "",
      qrDialog: false,
      qrDownloadLoading: false,
      clearUserAssessmentSuccessSnackbar: false,
      clearUserAssessmentFailureSnackbar: false,
      debouncedSearch: null,
      HrEvaluationMailSnackBar: false,
      assessmentReminderSnackBar: false,
      notifyUserDetails: {},
      currentSelectedStatus: 'ALL',
      shortCampaignLink: null,
      filters: {},
      selectedStatus: 'ALL',
      statusMap: [
        { status: 'ALL', count: '...' },
        { status: 'ACTIVE', count: '...' },
        { status: 'CLOSED', count: '...' },
      ],
      closeApplicationDialog: false,
      closeApplicationSuccessDialog: false,
      closeApplicationForUser: {
        status: "CLOSED",
        userId: "",
        remarksInfo: {
          remarks: "",
          closedBy: {
            userName: "",
            email: "",
          },
        }
      },
      maxRemarksCharacters: 500,
      remarksLength: 0,
      closeApplicationLoader: false,
      editorConfig: {},
      successIcon: require("../assets/success.svg"),
      audienceCount: 0,
      preferredLocation: [],
      clusterData: [],
      clusterAndSchools: [],
      emailSnackbar: false,
      campaignMetaData: {},
      currentCampaignId: '',
      campaignAudienceAbortController: null,
      setStatusCountsAbortController: null,
      downloadingFeedback: false,
      feedbackUser:{},
      downloadAttendanceReport: false
    };
  },
  watch: {

    // Navigating between two campaigns' user views (both resolve to this same /campaignUser
    // route, differing only in the ?id= query) reuses this component instance - created()/
    // mounted() do NOT re-run, so without this watch the funnel keeps listening to whichever
    // campaign was active when the instance was first created. Scoped to just re-arming the
    // funnel listener (not immediate, since mounted() already covers the first load) so it
    // doesn't touch pagination/table/filter state or their existing behavior.
    '$route.query.id'(newId, oldId) {
      if (newId && newId !== oldId) {
        this.id = newId;
        this.setupSnapshotListenerFunnel(newId);
      }
    },

    currentCampaignId: {
      immediate: true,
      handler() {
        this.restorePageState()
      }
    },
    selectedSubjectFilters(newValue) {
      if (newValue.length !== 1) {
        this.selectedRankFilters = null;
      }
    },

    selectedClusterFilters(newClusters) {
      this.preferredLocation = [...new Set(newClusters.flatMap(cluster =>
        this.clusterAndSchools[cluster] || []
      ))];
    },

    selectedSchoolCitiesFilter(newValue) {
      this.selectedClusterFilters = [];
      this.selectedLocationFilters = [];
    },

    selectedDepartmentFilter(newValue) {
      this.selectedJobRolesFilters = [];
    },

  },

  mounted() {
    this.setupSnapshotListenerFunnel(this.id);
    this.restorePageState(this.id);
    this.copyToClipboard();
    this.getFilterValues();
    this.fetchCampaignAudience();

    this.$nextTick(() => {
      const wrapper = this.$el.querySelector('.v-data-table__wrapper');
      if (wrapper) {
        wrapper.id = 'myScroll';
      }
    });


  },
  computed: {


    isCustomDate() {
      return !this.dateData.map(({ value }) => value).includes(this.selectedDateFilters);
    },

    stepperStages() {
      // Always start with Invited
      const steps = [{ label: "Registered" }];

      // Get the numberOfRounds array
      const rounds = this.campaignMetaData?.numberOfRounds || [];
      // Iterate directly over the array
      rounds.forEach((round) => {
        steps.push({ label: round.charAt(0).toUpperCase() + round.slice(1) });
      });
      return steps;
    },

    isFilterEnable() {
      return Boolean(
        this.selectedClusterFilters?.length ||
        this.selectedDemoFilters?.length ||
        this.selectedInterviewsFilters?.length ||
        this.selectedJobRolesFilters.length ||
        this.selectedLeagueFilters.length ||
        this.selectedLevelFilters.length ||
        this.selectedMainsFilters.length ||
        this.selectedScreeningFilters.length ||
        this.selectedLocationFilters.length ||
        this.selectedDateFilters ||
        this.selectedRankFilters ||
        this.selectedSubjectFilters.length ||
        this.selectedDepartmentFilter.length ||
        this.selectedCandidateDecisionFilter.length ||
        this.selectedSourceFilter.length ||
        this.selectedGroupFilter.length > 0
      );
    },
    getLatestStatusFromFilter() {
      const getLatestStatus = new Set([
        ...this.selectedScreeningFilters,
        ...this.selectedMainsFilters,
        ...this.selectedDemoFilters.flat(),
        ...this.selectedInterviewsFiltersWithRounds
      ]);
      return Array.from(getLatestStatus)?.flat();
    },
    receivedFeedbackCount() {
      return this.currentRoundFeedback.length
    },
    totalFeedbackCount() {
      return this.currentRoundFeedback.length + this.pendingCurrentRoundfeedback.length
    },
  },
  methods: {
    getLevelAlias(levels) {
      const key = Array.isArray(levels) ? levels[0] : levels
      return this.campaignMetaData?.nameAliases?.levels?.[key] ?? key
    },
    async resetInterviewNotificationBadge(item) {
      try {
        let payload = {
          userId: item.userId,
          badgeName: 'showFeedbackNotificationBadge'

        }
        const res = await CampaignController.resetInterviewNotificationBadge(payload)

      } catch (error) {
        console.log(error)
      }
    },
    async openFeedbackDialog(item) {

      this.feedbackUser = item;
      this.downloadAttendanceReport = item.interviewDetails?.interviewSlotDetails[this.selectedRound -1]?.interviewMode == "Online";
      let round = item?.round || 1

      if (item?.interviewFinalStatus?.status === "ROUND_ACCEPTED" && Number(round) !== Number(item?.interviewFinalStatus?.round)) {
        return false;
      }

      await this.resetInterviewNotificationBadge(item)
      item.showFeedbackNotificationBadge = false
      this.feedbackItem = item
      // Let the user toggle across every round up to the current one.
      const maxRound = Number(round) || 1
      this.feedbackRounds = Array.from({ length: maxRound }, (_, i) => i + 1)
      this.viewFeedbackDialog = true
      this.loadRoundFeedback(maxRound)
    },
    loadRoundFeedback(round) {
      const item = this.feedbackItem
      if (!item) return
      this.selectedRound = Number(round)
      this.downloadAttendanceReport = item.interviewDetails?.interviewSlotDetails[this.selectedRound -1]?.interviewMode == "Online";
      // Prefer allSlotDetails, falling back to interviewSlotDetails — same
      // fallback used in ScheduleInterviewRounds.vue's isReshedule().
      const slotDetails = item.interviewDetails.allSlotDetails || item.interviewDetails.interviewSlotDetails || []
      const roundSlot = slotDetails[round - 1] || {}
      const interviewerNameAndEmail = roundSlot.interviewerNameAndEmail || []
      const interviewerEmails = roundSlot.interviewerEmails || []
      const hasNameMapping = interviewerNameAndEmail.length > 0
      const nameByEmail = new Map(interviewerNameAndEmail.map(({ email, name }) => [email, name]))

      const roundFeedback = item?.interViewFeedback?.filter(fb => Number(fb.round) === Number(round)) || []
      const submittedEmails = roundFeedback.map(({ interviewerEmail }) => interviewerEmail)
      this.currentRoundFeedback = this.getColColors(roundFeedback).map((feedback) => ({
        ...feedback,
        interviewerName: nameByEmail.get(feedback.interviewerEmail) || feedback.interviewerEmail,
      }))
      this.pendingCurrentRoundfeedback = hasNameMapping
        ? interviewerNameAndEmail.filter(({ email }) => !submittedEmails.includes(email))
        : interviewerEmails.filter(email => !submittedEmails.includes(email))
      this.measureCommentTruncation()
    },
    getFeedbackRoundButtonClass(round) {
      return this.selectedRound === round
        ? 'blue white--text text-subtitle-2'
        : 'gray-02 blue--text text-subtitle-2'
    },
    async openInterviewerFeedbackDetail(feedbackCard) {
      const item = this.feedbackItem
      if (!item) return
      try {
        this.detailFeedbackLoading = true
        const response = await CampaignController.getInterviewReport(item.userId, item.campaignId || this.id)
        const result = response?.data?.result || {}
        this.detailFeedbackPersonalInfo = result?.personalInfo || null
        this.detailFeedbackInterviewDetails = result?.interviewDetails || null
        this.detailFeedbackProctoringPic = result?.proctoringPic || null
        this.detailFeedbackList = result?.interViewFeedback || []
        this.detailFeedbackInterviewerEmail = feedbackCard.interviewerEmail
        this.detailFeedbackRound = this.selectedRound
        this.interviewFeedbackDetailDialog = true
      } catch (error) {
        console.error(error)
      } finally {
        this.detailFeedbackLoading = false
      }
    },
    getColColors(data = []) {
      return data.map((item, index) => {
        if (["Not Recommended", "Below Standard"].includes(item.recommendation)) {
          item['bgClass'] = 'rejected-bg'
          // this.textColors[index] = 'rejected-txt'
        } else if (["On Hold", "Moderately Recommended"].includes(item.recommendation)) {
          item['bgClass'] = 'hold-bg'
          // this.textColors[index] = 'hold-txt'
        } else if (["Highly Recommended", "Strongly Recommended", "Recommended"].includes(item.recommendation)) {
          item['bgClass'] = 'recommended-bg'

          // this.textColors[index] = 'recommended-txt'
        }
        return item
      })
    },
    async getAudienceRoleGroups() {
      const response = await AudienceRolesController.getAudienceRoleGroups();
      if (response.status == 200) {
        this.groupData = response.data.audienceRoleGroup.map(({ name }) => name);
      }
    },
    formatStatus(str) {
      const camel = str
        .toLowerCase()
        .replace(/[-_ ]+(\w)/g, (_, c) => c.toUpperCase());

      return camel.charAt(0).toUpperCase() + camel.slice(1);
    },
    setAudienceTableHeaders() {
      //For userTypes Jobseeker and Teacher
      if (this.campaignMetaData.numberOfRounds?.includes("screening")) {
        this.headers = [
          { text: 'Name', value: 'name', width: '190px', sortable: false },
          { text: 'Email ID', value: 'email', width: '190px', sortable: false, cellClass: "text-lowercase" },
          { text: 'Location', value: 'location', sortable: false, width: '190px', },
          { text: 'Job Role', value: 'jobrole', sortable: false, width: '190px', },
          { text: 'Stages', value: 'stages', sortable: false, width: '10%' },
          { text: 'Status', value: 'status', sortable: false, width: '15%', align: 'center' },
          { text: 'League', value: 'league', sortable: false, width: '10%' },
          { text: 'Action', value: 'actions', sortable: false, width: '10%' },
        ]
      }

      if (this.campaignMetaData.isExternalClient && this.campaignMetaData?.reportGeneration?.reportType !== 'gtoReport') {
        this.headers.splice(2, 0, { text: 'Proficiency Level', value: 'proficiencyLevel', sortable: false, width: '15%' });
        this.headers.splice((this.headers.length - 1), 0, { text: 'League', value: 'league', sortable: false, width: '15%' });
      }

      if (this.campaignMetaData.isExternalClient) {
        this.headers.splice(2, 0, { text: 'Level', value: 'levels', sortable: false, width: '10%' });
        const stagesHeader = this.headers.find(({ value }) => value === 'stages');
        stagesHeader.width = '25%';
      }
    },
    async getCampaignMetaData() {
      const response = await CampaignController.getCampaignMetaData(this.id);
      this.campaignMetaData = response.metaData;
    },
    async getFilterValues() {
      try {
        const response = await CampaignController.getCampaignFilters(this.currentCampaignId);
        this.sourceData = response.filters[0].source;
        this.schoolCitiesData = response.filters[0].schoolCities;
        this.departmentData = response.filters[0].departments;

        this.interviewsData = response.filters[0].interviewStatus;
        // this.interviewsData = response.filters[0].interviewStatus.map(status => ({
        //   originalStatus: status,
        //   readableStatus: InterviewConstants.interviewConstants(round)[status] || "Unknown"
        // }));

        this.leagueData = response.filters[0].League
        this.levelData = response.filters[0].level;
        this.subjectData = response.filters[0].subject;
        this.jobRolesData = response.filters[0].preferredJobRole;
        this.clusterAndSchools = response.filters[0].clusterAndSchool;
        this.clusterData = Object.keys(this.clusterAndSchools);
        this.audienceCount = 20;
        this.getFilteredRankData()


      } catch (error) {
        return error.response;
      }
    },
    getFilteredRankData() {
      if (this.audienceCount < 10) {
        return this.rankData.slice(0, 1);
      }

      if (this.audienceCount < 50) {
        return this.rankData.slice(0, 2);
      }

      if (this.audienceCount < 100) {
        return this.rankData.slice(0, 3);
      }

      return this.rankData; // 100 or more
    },
    selectUser(userData) {
      this.selectedUser = userData;
    },
    setStatusFilter(status) {
      this.currentSelectedStatus = status;
      this.fetchCampaignAudience(this.currentSelectedStatus)
    },
    deriveStatus(user) {
      const finalStatus = ['ACCEPT', 'REJECT', 'ONHOLD', 'SEND_TO_HIRING_MANAGER'];
      const status = user?.interviewFinalStatus?.status?.toUpperCase();
      const interviewRound = user?.interviewFinalStatus?.round;
      const userRound = user?.round;
      const isFeedbackCompleted = this.isInterviewFeedbackComplete(user);
      const isReschedule = user?.hasTimeChanged || user.isReshedule
      const numberOfRounds = user.numberOfRounds || []
      const currentTestRoundIndex = user.currentTestRoundIndex
      const allSlotDetailsIndex = user?.interviewDetails?.allSlotDetails?.[userRound - 1]?.timeSlotDetails?.index ?? 0
      const soltStatus = user?.interviewDetails?.allSlotDetails?.[userRound - 1]?.slotStatus ?? ''
      /// indegate slot details api for status 
      if(allSlotDetailsIndex > 7 && soltStatus == "PENDING" ){
        return "SLOT_REQUESTED"
      }
      if(allSlotDetailsIndex > 7 && soltStatus == "REJECTED" ){
        return "SLOT_REJECTED"
      }
      if (user?.status === 'CLOSED') return 'APPLICATION_CLOSED';
      if (finalStatus.includes(status)) {
        return status;
      }

      if (status === 'ROUND_ACCEPTED') {
        if (isFeedbackCompleted) {
          return 'INTERVIEW_COMPLETED';
        } else if (userRound === interviewRound) {

          return isReschedule ? 'RESCHEDULED' : 'SCHEDULED';
        }
        return 'ROUND_ACCEPTED';
      }

      if (userRound > 0) {
        return isFeedbackCompleted ? 'INTERVIEW_COMPLETED' : isReschedule ? 'RESCHEDULED' : 'SCHEDULED';
      }
 
      if (currentTestRoundIndex < numberOfRounds.length - 1) {
        return 'NOT_APPLICABLE'
      }
    },
    getStatusClass(user) {
      let status = this.deriveStatus(user)
      let round = user.round || 1
      let display = status == 'SCHEDULED' ? 'number' : 'icon'

      switch (status) {
        case 'ACCEPT':
          return { class: 'accepted-status', round, icon: require('../assets/check-1.svg'), display, statusName: 'Accepted' };
        case 'SCHEDULED':
          return { class: 'scheduled-status', round, icon: require('../assets/check-1.svg'), display, statusName: 'Scheduled' };
        case 'REJECT':
          return { class: 'rejected-status', round, icon: require('../assets/close-1.svg'), display, statusName: `Rejected at R${round}` };

        case 'ONHOLD':
          return { class: 'on-hold-status', round, icon: require('../assets/warning-sign.svg'), display, statusName: 'On Hold' };

        case 'INTERVIEW_COMPLETED':
          return { class: 'interview-completed-status', round, icon: require('../assets/check-1.svg'), display, statusName: 'Interview Completed' };

        case 'SEND_TO_HIRING_MANAGER':
          return { class: 'hiring-manager-status', round, icon: require('../assets/check-1.svg'), display, statusName: 'Sent to Hiring Manager' };

        case 'NOTIFY_HR':
          return { class: 'notify-hr-status', round, icon: require('../assets/check-1.svg'), display, statusName: 'Notified HR' };

        case 'ROUND_ACCEPTED':
          return { class: 'notify-hr-status', round, icon: require('../assets/check-1.svg'), display, statusName: `Accepted at R${round}` };

        case 'RESCHEDULED':
          return { class: 'scheduled-status', round, icon: require('../assets/check-1.svg'), display, statusName: 'Rescheduled' };

        case 'APPLICATION_CLOSED':
          return { class: 'closed-status', round, icon: '', display, statusName: 'Closed' };

        case 'NOT_APPLICABLE':
          return { class: 'not-scheduled-status', round, icon: '', display, statusName: 'Not Applicable' };

        case "SLOT_REQUESTED":
        return { class: 'scheduled-status', round, icon: require('../assets/check-1.svg'), display, statusName: 'Slot Requested' };

        case "SLOT_REJECTED":
        return { class: 'rejected-status', round, icon: require('../assets/close-1.svg'), display, statusName: 'Slot Rejected' };
        
        default:
          return { class: 'not-scheduled-status', round, icon: '', statusName: 'Not Scheduled' };
      }
    },
    confirmHrEvaluation(data) {
      this.notifyUserDetails = data
      this.isHrAction = true
    },
    sendHrEvalMail() {
      let { fName, lName, email, userId, stage, deviceType, jobRole } = this.notifyUserDetails;
      this.notifyUserForAssessment(fName, lName, email, userId, stage, deviceType, jobRole)
      this.isHrAction = false;
    },
    async notifyUserForAssessment(firstName, lastName, email, userId, assessmentStage, deviceType, jobRole) {
      try {
        const response = await MailController.notifyUserForAssessment(
          `${firstName} ${lastName}`,
          email,
          userId,
          this.id,
          assessmentStage,
          deviceType,
          jobRole
        )

        this.HrEvaluationMailSnackBar = true
        return response;
      }
      catch (error) {
        return error.response;
      }

    },
    ...mapActions(['savePaginationState', 'clearPaginationStates']),
    async onFooterUpdate(newOptions) {
      this.savePaginationState({
        campaignId: this.currentCampaignId,
        paginationState: {
          page: newOptions.page,
          itemsPerPage: newOptions.itemsPerPage,
        }
      })

      this.options = { ...this.options, ...newOptions };
      this.pageSize = this.options.itemsPerPage;
      this.page = this.options.page;
      this.users = [];
      this.isLoading = true;
      this.search = this.$route.query.search || ''

      await this.$nextTick();
      await this.fetchCampaignAudience();
    },
    getStepperClasses(index, step) {
      const stepColor = this.stepper.get(index)[step]?.iconColor;
      return {
        'pass-step': stepColor === 'green',
        'fail-step': stepColor === 'red'
      }
    },
    calculateInterview(data = []) {
      if (data.length === 0) return 0;

      let maxRound = Math.max(...data.map(element => Number(element.round)));

      let interviewAvgScore = 0;
      let filteredData = data.filter(element => Number(element.round) === maxRound);

      if (filteredData.length === 0) {
        maxRound--;
        filteredData = data.filter(element => Number(element.round) === maxRound);
      }

      if (filteredData.length > 0) {
        interviewAvgScore = filteredData.reduce((sum, element) => sum + parseFloat(element.avgScore), 0) / filteredData.length;
      }

      return interviewAvgScore;
    },
    isInterviewFeedbackComplete(item) {
      if(!item.round){
        return false 
      }
      if (item?.interviewFinalStatus?.status === "ROUND_ACCEPTED" && Number(item?.round) !== Number(item?.interviewFinalStatus?.round)) {
        return false;
      }

      const roundIndex = item.round - 1; // Adjust for zero-based index
      // Get emails for the current round
      const emails = item?.interviewDetails?.allSlotDetails?.[roundIndex]?.interviewerEmails || item?.interviewDetails?.interviewSlotDetails?.[roundIndex]?.interviewerEmails || [];

      // Get feedback objects for the current round
      const feedbackForRound = item?.interViewFeedback?.filter(fb => Number(fb.round) === Number(item.round)) || [];

      // Check if every email in the slot has a corresponding feedback entry
      const totalInvited = emails.length;

      // All feedbacks are required
      let requiredFeedback = totalInvited;
      // if (totalInvited >= 3) {
      //   requiredFeedback = totalInvited - 1;
      // } else {
      //   requiredFeedback = totalInvited;
      // }

      // count feedbacks received
      const feedbackReceived = emails.filter(email =>
        feedbackForRound?.some(fb => fb.interviewerEmail === email)
      ).length;
      // check if complete
      const isComplete = totalInvited > 0 && feedbackReceived >= requiredFeedback;
      return isComplete;

    },
    hasCurrentRoundFeedback(item) {
      if (item?.interviewFinalStatus?.status === "ROUND_ACCEPTED" && Number(item?.round) !== Number(item?.interviewFinalStatus?.round)) {
        return false;
      }

      const feedbackForRound = item?.interViewFeedback?.filter(fb => Number(fb.round) === Number(item.round)) || [];
      return feedbackForRound.length > 0;
    },
    isInterviewInProgress(item) {
      if (item?.interviewFinalStatus?.status === "ROUND_ACCEPTED" && Number(item?.round) !== Number(item?.interviewFinalStatus?.round)) {
        return false;
      }
      const feedbackForRound = item?.interViewFeedback?.filter(fb => Number(fb.round) === Number(item.round)) || [];
      const isInProgress = feedbackForRound.length > 0
      return isInProgress;
    },
    isInterviewHistory(item) {
      return !item?.interviewDetails && !(this.$store.state.role?.interview?.read ?? false)
    },
    addInterviewScoreAndModifyVals(data) {
      this.users = data.map((item) => {
        return { interveiwScore: this.calculateInterview(item?.interViewFeedback), modifiedLocation: this.elipsisAndMore(item, 'location'), modifiedJobRoles: this.elipsisAndMore(item, 'jobRoles'), ...item }
      })
    },
    elipsisAndMore(item, fieldName) {
      if (fieldName == 'location') {
        return this.showItemsAndMoreLength(this.showSchools(item.teachingInterests))
      } else if (fieldName == 'jobRoles') {
        return this.showItemsAndMoreLength(this.showJobRoles(item.teachingInterests))
      }
    },
    restorePageState() {
      const savedState = this.$store.state.campaignPaginationStates[this.currentCampaignId]
      if (savedState) {
        this.currentPage = savedState.page
        this.options.itemsPerPage = savedState.itemsPerPage
        this.options = { ...this.options, ...savedState }
      } else {
        this.resetToDefaultPagination()
      }
    },
    isInterviewHistory(item) {
      return !item?.interviewDetails
    },
    addInterviewScoreAndModifyVals(data) {
      this.users = data.map((item) => {
        return { interveiwScore: this.calculateInterview(item?.interViewFeedback), modifiedLocation: this.elipsisAndMore(item, 'location'), modifiedJobRoles: this.elipsisAndMore(item, 'jobRoles'), ...item }
      })
    },
    elipsisAndMore(item, fieldName) {
      if (fieldName == 'location') {
        return this.showItemsAndMoreLength(this.showSchools(item.teachingInterests))
      } else if (fieldName == 'jobRoles') {
        return this.showItemsAndMoreLength(this.showJobRoles(item.teachingInterests))
      }
    },
    restorePageState() {
      const savedState = this.$store.state.campaignPaginationStates[this.currentCampaignId]
      if (savedState) {
        this.currentPage = savedState.page
        this.options.itemsPerPage = savedState.itemsPerPage
        this.options = { ...this.options, ...savedState }
      } else {
        this.resetToDefaultPagination()
      }
    },
    resetToDefaultPagination() {
      this.currentPage = 1
      this.options.itemsPerPage = 10
      this.options = { ...this.options, page: 1, itemsPerPage: 10 }
    },


    canScheduleInterview(item) {
      return (this.$store.state.role?.interview?.read ?? false) && item.enableScheduleInterview;
    },
    isTestReportEnabled(index, userType, userCurrentTestRoundIndex = 0) {
      return userCurrentTestRoundIndex > 0 || this.stepper.get(index).screening?.iconColor != "grey";
    },
    isUserReportEnabled(index, userType) {
      if (userType != 'Teacher') {
        return this.stepper.get(index).interview.stepType == "showMarks";
      } else {
        // return this.stepper.get(this.users.indexOf(item)).screening.iconColor == 'green' &&
        return false;
        //  this.stepper.get(this.users.indexOf(item)).demo.iconColor == 'green';
      }
    },
    snapPromise(ref) {
      let data = []
      return new Promise((res) => {
        let unsubscribe = onSnapshot(ref, (snap) => {
          if (!snap.empty) {
            snap.docs.map((doc) => data.push(doc.data()))
          }
          res(data)
        })
        this.liveListenersToUnsubscribeMixin.push(unsubscribe);
      })
    },
    getSubSorted(data) {
      if (data?.length) {
        return data.sort((a, b) => {
          const subA = a.subjectName.toUpperCase();
          const subB = b.subjectName.toUpperCase();
          if (subA < subB) {
            return -1;
          }
          if (subA > subB) {
            return 1;
          }

          return 0;
        })
      }
      return data

    },
    getCoreNonCoreSkill(data, core) {
      if (data?.length) {
        if (core) {
          return data.filter(item => item.isCoreSkill)
        } else {
          return data.filter(item => !item.isCoreSkill)
        }

      }
    },
    getNonCoreObj(data) {
      let obj = {};
      if (data?.length) {
        data.forEach((item) => {
          obj[item.subjectName] = item.score;
          obj[`${item.subjectName}_maximumMarks`] = item.maximumMarks
        })
      }
      return obj
    },
    getSceeningMainsStatusAndTime(campaignStatus, type) {
      if (type == 'screening') {
        if (campaignStatus[2]) {
          return campaignStatus[2]
        } else {
          return campaignStatus[1] || { status: '', time: '' }
        }
      } else {
        if (campaignStatus[4]) {
          return campaignStatus[4]
        } else {
          return campaignStatus[3] || { status: '', time: '' }
        }
      }

    },
    getTeacherItems(items, key) {
      return items.map(item => item[key]).join()
    },
    evalZeors(score = -1) {
      let hasDecimal = (score - Math.floor(score)) !== 0;
      if (score >= 0) {
        return hasDecimal ? `${score}/10` : `${score}.0/10`
      }
      return 'NA'
    },
    getRecommendation(coreSkills = {}, interviewFeedback = []) {
      let recommendedSubjects = [];
      let notRecommendedSubjects = [];
      let onHoldSubjects = [];
      let interviewSubXmarks = this.getInterveiwSubjectsAndPercent(interviewFeedback, coreSkills);
      coreSkills.forEach((subject) => {
        let finalPercent = this.getFinalPercent(subject.percentile, interviewSubXmarks.get(subject.subjectName))
        if (finalPercent > 0 && finalPercent < 40) {
          notRecommendedSubjects.push(subject.subjectName)
        } else if (finalPercent >= 40 && finalPercent < 60) {
          onHoldSubjects.push(subject.subjectName)
        } else if (finalPercent >= 60) {
          recommendedSubjects.push(subject.subjectName)
        }
      })
      return { recommend: recommendedSubjects.join(), hold: onHoldSubjects.join(), notRecommended: notRecommendedSubjects.join() }
    },

    getInterveiwSubjectsAndPercent(interviewData, coreSkills) {
      let interviewSubMap = new Map();
      let subjects = coreSkills?.map(item => item.subjectName);
      subjects?.forEach((subject) => {
        let subPercent = []
        interviewData?.forEach((interview) => {
          let subjectData = interview.subjects.filter((interviewsub) => interviewsub.subjectName == subject)
          subPercent.push(this.ratingSum(subjectData[0].feedback) / subjectData[0].feedback.length * 100 / 10)
        })
        interviewSubMap.set(subject, this.sumPercentValues(subPercent) / subPercent.length)
      })
      return interviewSubMap
    },
    ratingSum(feeback) {
      return feeback.reduce((acc, cur) => {
        return acc + cur.rating
      }, 0)
    },
    sumPercentValues(data) {
      return data.reduce((acc, cur) => acc + cur, 0)
    },
    getFinalPercent(systemPercent, interviewPercent) {
      return (systemPercent + interviewPercent) / 2;
    },
    getNetScore(data) {
      let netScore = 0;
      if (data?.length) {
        data?.forEach((skil) => {
          netScore = netScore + parseFloat(skil.finalNetScore);
        });
        netScore = netScore / data.length;
        return netScore = !isNaN(netScore) ? netScore.toFixed(2) : 0.00;
      }
      return netScore
    },
    getMainsScoreOutOfTen(data = {}) {
      let res = 0
      if (data.hasOwnProperty('score') && data.hasOwnProperty('maximumMarks')) {
        res = ((parseFloat(data.score) / parseFloat(data.maximumMarks)) * 10).toFixed(1);
      }
      return res !== 'NaN' ? res : '0'
    },
    getSubjectWiseDemoAvgScore(demoData = new Array(3).fill("")) {
      let res = {}
      demoData.length < 3 ? demoData.push(...new Array(3 - demoData.length).fill("")) : ''
      demoData.forEach((item, index) => {
        delete item.name
        const totalNumOfParams = Object.values(item)?.length
        res[`subject_${index + 1}_demo_avg_score`] = item !== "" ? (Object.values(item).reduce((acc, cur) => acc + cur, 0) / totalNumOfParams) : 'NA'
      })
      return res;
    },
    getDemoScores(demoData = new Array(3).fill("")) {
      let res = {}
      demoData.length < 3 ? demoData.push(...new Array(3 - demoData.length).fill("")) : ''
      demoData.forEach((item, index) => {
        res[`subject_${index + 1}_Knowledge_Level_Score`] = item !== "" ? item?.knowledgeLevel || 'NA' : 'NA';
        res[`subject_${index + 1}_Confidence_Level_Score`] = item !== "" ? item?.confidenceLevel || 'NA' : 'NA';
        res[`subject_${index + 1}_Behavior_Level_Score`] = item !== "" ? item?.behaviorlLevel || 'NA' : 'NA';
        res[`subject_${index + 1}_Fluency_Level_Score`] = item !== "" ? item?.fluencyLevel || 'NA' : 'NA'
      })
      return res;
    },
    async downlaodCamapignUserDetails() {
      const getDateInDDMMYYYY = () => {
        const today = new Date(
          new Intl.DateTimeFormat('en-US', {
            timeZone: 'Asia/Kolkata',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
          }).format(new Date()))
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); // Month is zero-based
        const yyyy = today.getFullYear();

        return `${dd}${mm}${yyyy}`;
      };
      this.downloadLoader = true;
      try {
        // Prepare filter data same way
        let schools = (this.$store.state.userInfo?.role?.schools && this.$store.state.userInfo?.role?.schools !== "All" && this.$store.state.userInfo?.role?.schools.length > 0)
          ? [this.$store.state.userInfo?.role?.schools]
          : this.selectedLocationFilters;

        let clusters = (this.$store.state.userInfo?.role?.clusterName && this.$store.state.userInfo?.role?.clusterName !== "All Clusters")
          ? [this.$store.state.userInfo?.role?.clusterName]
          : this.selectedClusterFilters;

        let status;
        if (this.selectedStatus !== "ALL") {
          status = this.selectedStatus;
        }
        const nullSafeSearch = typeof this.search === 'string' && this.search.toLowerCase() !== 'null' && this.search.toLowerCase() !== 'undefined' ? this.search : '';
        let body = {
          campaignId: this.id,
          clusters: clusters,
          latestStatus: this.getLatestStatusFromFilter,
          interviewAcceptedRounds: this.interviewAcceptedRoundsFilter,
          interviewRejectedRounds: this.interviewRejectedRoundsFilter,
          userCreatedAt: this.sendSelectedDateFilter ?? [],
          levels: this.selectedLevelFilters,
          leagues: this.selectedLeagueFilters,
          schools: schools,
          jobRole: this.selectedJobRolesFilters,
          subjects: this.selectedSubjectFilters,
          rank: this.selectedRankFilters ?? [],
          status: status,
          departments: this.selectedDepartmentFilter,
          group: this.selectedGroupFilter,
          boards: this.selectedBoardsFilter,
          search: nullSafeSearch,
          candidateDecision: this.candidateDecisionFilter ?? {},
          sources: this.selectedSourceFilter,
          filterApplied: this.filterCount >= 2 || (this.filterCount > 0 && (this.roleCluster !== '' || this.roleSchool !== '' || this.interviewRejectedRoundsFilter?.length > 0 || this.interviewAcceptedRoundsFilter?.length > 0))
        };
        // Call backend CSV endpoint with POST
        const response = await CampaignController.downloadCampaignAudience(body)
        if (response.status != 200) {
          throw new Error('Failed to download CSV');
        }
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv' }));
        const link = document.createElement('a');
        link.href = url;
        const date = getDateInDDMMYYYY();
        const fileName = this.campaignName + `_${date}` + ".csv";
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        console.error(error);
      } finally {
        this.downloadLoader = false;
      }
    },
    sortCsvOnMainsNetScoreDesc(csv) {
      return csv.sort((a, b) => b.Mains_net_score - a.Mains_net_score)
    },
    formatCreatedDate(date) {
      if (date == '' || date == null || date == undefined) {
        return "NA"
      }
      date = new Date(date)
      return (
        String(date.getDate()).padStart(2, "0") +
        "/" +
        String(date.getMonth() + 1).padStart(2, "0") +
        "/" +
        String(date.getFullYear()).padStart(2, "0")
      );
    },
    showSchools(teachingInterests = {}) {
      const schools = Array.isArray(teachingInterests?.schools)
        ? [...teachingInterests?.schools]
        : [teachingInterests?.schools];

      const otherLocations = Array.isArray(teachingInterests?.otherlocation)
        ? [...teachingInterests?.otherlocation]
        : [teachingInterests?.otherlocation];

      return [...schools, ...otherLocations].filter(Boolean).join(", ");
    },
    showItemsAndMoreLength(data) {
      let stringToArray = data.split(',') || []
      let firstString = stringToArray[0]
      let firstVal = firstString.length > 15 ? `${firstString.slice(0, 15)}...` : firstString
      let secondval = stringToArray.length > 1 ? `, +${stringToArray.slice(1, stringToArray.length).length}` : ''
      return { displayValue: firstVal + secondval, tooltipValue: data };
    },
    showJobRoles(teachingInterests = {}) {
      if (teachingInterests?.jobRole?.HRIS_unique_role) {
        const jobRole = [teachingInterests?.jobRole.HRIS_unique_role]
        const otherJobRole = teachingInterests?.otherJob ?? [];
        return [...jobRole, ...otherJobRole].join(", ");
      } else {
        return ''
      }


    },
    convertArrayToCommaSepratedVals(data) {
      if (typeof data == 'string') {
        return data;
      } else if (Array.isArray(data)) {
        return data.join(", ")
      } else {
        return 'NA'
      }
    },
    getFullName(info) {
      let keys = ['firstName', 'middleName', 'lastName']
      return keys.map((key) => info.hasOwnProperty(key) ? `${info[key]}` : '').join(" ")

    },
    downloadCSV(csvData, fileName) {
      const csv = Papa.unparse(csvData);

      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        const link = document.createElement("a");
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", fileName);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    },
    async downloadQrCode() {
      // qrDownloadRef
      this.qrDownloadLoading = true;
      html2canvas(this.$refs.qrDownloadRef).then((canvas) => {
        let link = document.createElement("a");
        // link.download = 'screenshot.jpg';
        link.download = `${this.campaignName}.jpg`;
        link.href = canvas.toDataURL("image/jpeg", 0.5);
        link.click();
      });
      this.qrDownloadLoading = false;
    },

    async generateQRCode() {
      try {
        this.qrLoading = true;
        const id = this.id;
        const audienceType = this.campaignType;

        let shortCampaignLink = `https://${this.$FRONTEND_DOMAIN}/#/campaignInvite?campaignId=` + id;

        if (audienceType.toLowerCase() !== "teacher") {
          shortCampaignLink = `https://${this.$FRONTEND_DOMAIN}/#/welcome`;

          // const apiRes = await axios.post(
          //   `https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=${app.options.apiKey}`,
          //   {
          //     longDynamicLink: campaignLink,
          //     suffix: {
          //       option: "SHORT",
          //     },
          //   }
          // );

          // if (apiRes?.data?.shortLink) {
          //   shortCampaignLink = apiRes?.data?.shortLink;
          // }
        }
        this.qrCampaignLink = shortCampaignLink;
        this.qrLoading = false;
        this.qrDialog = true;
      } catch (err) {
        console.error(err);
        this.qrLoading = false;
      }
    },
    manageDialog(data) {
      this.scheduleInterviewDialog = data;
      this.fetchCampaignAudience();
    },
    copyEmailId(emailId) {
      navigator.clipboard
        .writeText(emailId)
        .then(() => {
          this.emailSnackbar = true;
        })
    },
    copyLink() {
      navigator.clipboard
        .writeText(this.shortCampaignLink)
        .then(() => {
          this.snackbar = true;
        })
    },
    async copyToClipboard() {

      if (this.campaignType.toLowerCase() !== "teacher") {
        // const campaignLink = `https://${this.$DEEPLINK}/?link=https%3A%2F%2F${this.$FRONTEND_DOMAIN}%2F%23%2Fwelcome&apn=${this.$PACKAGE_NAME}&afl=https%3A%2F%2F${this.$FRONTEND_DOMAIN}%2F%23%2Fwelcome&isi=6446600030&ibi=${this.$PACKAGE_NAME}&ifl=https%3A%2F%2F${this.$FRONTEND_DOMAIN}%2F%23%2Fwelcome`;
        this.shortCampaignLink = `https://${this.$FRONTEND_DOMAIN}/#/welcome`
        // const apiRes = await axios.post(
        //   `https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=${app.options.apiKey}`,
        //   {
        //     longDynamicLink: campaignLink,
        //     suffix: {
        //       option: "SHORT",
        //     },
        //   }
        // );

        // if (apiRes?.data?.shortLink) {
        //   this.shortCampaignLink = apiRes?.data?.shortLink;
        // }
      }

    },

    getFinalResult(userId) {
      const { href } = this.$router.resolve({
        path: "/userreport",
        name: "UserReport",
        query: {
          campaignId: this.id,
          userId: userId,
          // Mark the User Report as opened from Campaigns so onward navigation
          // to multi-parent report pages keeps the Campaigns nav item active
          // (forwarded by PentagonChart / scheduleInterview).
          redirectedFrom: 'campaigns',
        },
      })

      window.open(href, '_blank')
    },

    async gotoScheduleInterview(userData, userStatus = '', isSchedule = true) {

      let query = this.$route.query;
      query['userId'] = userData.userId
      query['campaignName'] = this.campaignName;
      query['isSchedule'] = isSchedule;
      query['redirectedFrom'] = 'campaigns'
      if (userStatus) query['userStatus'] = userStatus;

      this.$router.push({ path: '/schedule-interview-rounds', query })
    },


    goBack() {

      this.$router.back();
    },

    onProgress(event) {
      if (event === 100) {
        this.downloadLoader = false;
      }
    },

    timeToMinutes(timeString) {
      var timeParts = timeString.split(":");
      var hours = parseInt(timeParts[0]);
      var minutes = parseInt(timeParts[1]);
      var seconds = parseInt(timeParts[2]);
      return (hours * 3600 + minutes * 60 + seconds) / 60;
    },

    openLeagueDialog(skillsList, firstName, lastName) {
      this.userName = firstName + " " + lastName;
      this.coreSkillsList = skillsList;
      this.leagueDialog = true;
    },

    clearFilter() {
      this.selectedClusterFilters = [];
      this.selectedBoardsFilter = [];
      this.selectedDateFilters = null;
      this.selectedLeagueFilters = [];
      this.selectedDemoFilters = [];
      this.selectedMainsFilters = [];
      this.selectedScreeningFilters = [];
      this.selectedInterviewsFilters = [];
      this.selectedRankFilters = [];
      this.selectedLevelFilters = [];
      this.selectedJobRolesFilters = [];
      this.selectedLevelFilters = [];
      this.selectedLocationFilters = [];
      this.sendSelectedDateFilter = null;
      this.selectedRankFilters = null;
      this.selectedSubjectFilters = [];
      this.selectedSchoolCitiesFilter = [];
      this.selectedDepartmentFilter = [];
      this.selectedAfterMainsDecisionFilter = [];
      this.selectedAfterScreeningDecisionFilter = [];
      this.selectedCandidateDecisionFilter = [];
      this.selectedSourceFilter = [];
      this.selectedOnBoardingDecisionFilter = [];
      this.candidateDecisionFilter = {
        quickfitment: [],
        detailfitment: [],
        onboarding: []
      }
      this.selectedGroupFilter = []
      this.selectedSort = "";
      this.sortCol = "mainsTotal";
      this.sortOrder = "desc";
      this.options.page = 1;
      this.fetchCampaignAudience();
      this.appliedFilter = false;
      this.filterCount = 0;
    },

    getSelectedSkillData(skill, index) {
      this.currenrSkillIndex = index;
      this.selectedSkill = skill;
      this.progressLevel =
        (this.selectedSkill.score / this.selectedSkill.maximumMarks) * 100;
    },

    getFilterCount() {
      this.filterCount = 0;
      const filters = {
        selectedClusterFilters: this.selectedClusterFilters,
        selectedBoardsFilter: this.selectedBoardsFilter,
        selectedLocationFilters: this.selectedLocationFilters,
        selectedJobRolesFilters: this.selectedJobRolesFilters,
        selectedLeagueFilters: this.selectedLeagueFilters,
        selectedDemoFilters: this.selectedDemoFilters,
        selectedMainsFilters: this.selectedMainsFilters,
        selectedScreeningFilters: this.selectedScreeningFilters,
        selectedInterviewsFilters: this.selectedInterviewsFilters,
        selectedLevelFilters: this.selectedLevelFilters,
        selectedSubjectFilters: this.selectedSubjectFilters,
        selectedDepartmentFilter: this.selectedDepartmentFilter,
        selectedSchoolCitiesFilter: this.selectedSchoolCitiesFilter,
        selectedCandidateDecisionFilter: this.selectedCandidateDecisionFilter,
        selectedSourceFilter: this.selectedSourceFilter,
        selectedGroupFilter: this.selectedGroupFilter
      };

      let filterCount = Object.values(filters).reduce(
        (count, filter) => (filter.length > 0 ? count + 1 : count),
        0
      );
      this.selectedDateFilters ? filterCount++ : '';
      this.selectedRankFilters ? filterCount++ : '';
      this.filterCount = filterCount;
    },


    logout() {
      this.clearPaginationStates();
      AuthService.logout();
      this.$router.push("/login");
    },
    getDateRange() {
      switch (this.selectedDateFilters) {
        case 'today':
          this.sendSelectedDateFilter = {
            start: format(startOfToday(), 'yyyy-MM-dd 00:00:00'),
            end: format(endOfToday(), 'yyyy-MM-dd 23:59:59')
          };
          break;
        case 'yesterday':
          this.sendSelectedDateFilter = {
            start: format(startOfYesterday(), 'yyyy-MM-dd 00:00:00'),
            end: format(endOfYesterday(), 'yyyy-MM-dd 23:59:59')
          };
          break;
        case 'this_week':
          this.sendSelectedDateFilter = {
            start: format(startOfWeek(new Date(), { weekStartsOn: 1 }), 'yyyy-MM-dd 00:00:00'),
            end: format(endOfWeek(new Date(), { weekStartsOn: 1 }), 'yyyy-MM-dd 23:59:59')
          };
          break;
        case 'last_week':
          const lastWeekDate = new Date(new Date().setDate(new Date().getDate() - 7));
          this.sendSelectedDateFilter = {
            start: format(startOfWeek(lastWeekDate, { weekStartsOn: 1 }), 'yyyy-MM-dd 00:00:00'),
            end: format(endOfWeek(lastWeekDate, { weekStartsOn: 1 }), 'yyyy-MM-dd 23:59:59')
          };
          break;
        case 'this_month':
          this.sendSelectedDateFilter = {
            start: format(startOfMonth(new Date()), 'yyyy-MM-dd 00:00:00'),
            end: format(endOfMonth(new Date()), 'yyyy-MM-dd 23:59:59')
          };
          break;
        case 'last_month':
          const lastMonthDate = new Date(new Date().setMonth(new Date().getMonth() - 1));
          this.sendSelectedDateFilter = {
            start: format(startOfMonth(lastMonthDate), 'yyyy-MM-dd 00:00:00'),
            end: format(endOfMonth(lastMonthDate), 'yyyy-MM-dd 23:59:59')
          };
          break;
        default:
          this.sendSelectedDateFilter = null;
          break;
      }
    },


    async getResult(data) {
      let url = ""
      if (data?.numberOfRounds) {
        if (data.numberOfRounds.includes('screening') || data.numberOfRounds.includes('mains')) {
          url = this.$router.resolve({ path: `/testreport/${this.id}/${data.userId}`, query: {redirectedFrom: 'campaigns'} }).href;
        } else if (data.numberOfRounds.includes('demo')) {
          url = this.$router.resolve({ path: `/demoreport/${this.id}/${data.userId}`, query: {redirectedFrom: 'campaigns'} }).href;
        } else if (data.numberOfRounds.includes('interview')) {
          url = this.$router.resolve({ path: `/interviewReport/${this.id}/${data.userId}`, query: {redirectedFrom: 'campaigns'} }).href;
        }
      } else {
        url = this.$router.resolve({ path: `/testreport/${this.id}/${data.userId}`, query: {redirectedFrom: 'campaigns'} }).href;
      }
      window.open(url, '_blank');
    },
    openInNewWindow(url = null) {
      if (url) {
        window.open(url, '_blank');
      }
    },
    searchData(search) {
      let user = this.preSearchUser;
      let searchString = this.removeSpaces(search);
      let usersList = user.filter((item) => {
        let searchByName = this.removeSpaces(item.personalInfo?.firstName + item.personalInfo?.lastName)
        let searchByEmail = this.removeSpaces(item.personalInfo.contactInfo?.email)
        return new RegExp(searchString, "i").test(searchByName) || new RegExp(searchString, "i").test(searchByEmail)
      }
      );
      this.users = this.calculateUsersForLeague(usersList);
    },
    removeSpaces(str = "") {
      return str?.replace(/\s/g, '');
    },
    getDate(timeStamp) {
      return this.formatDate(timeStamp);
    },
    filterByStatus(mainArray, statusToFilter) {
      return mainArray.filter((item) =>
        item.campaignStatus.some(
          (nestedItem) => nestedItem.status === statusToFilter
        )
      );
    },
    createStepperData(data) {
      data?.forEach((item, index) => {
        let obj = {
          invitation: { name: 'mdi-check-circle', iconColor: 'green' },
          screening: {},
          mains: {},
          demo: {},
          interview: {}
        }
        let status = item?.campaignStatus
        let userType = item?.userType || "Undefined";
        let roundsAssignedToUser = item?.numberOfRounds?.length > 0 ? item.numberOfRounds : ['screening', 'mains', 'demo', 'interview']
        let currentTestRoundIndex = item.currentTestRoundIndex
        let curentRound = roundsAssignedToUser[currentTestRoundIndex]

        if (this.campaignMetaData?.numberOfRounds?.length === 1) {
          let midStatus = !status[2]?.status && status[1]?.status?.toLowerCase().includes('started') ? 'started' : ''
          let mainsIcon = this.campaignMetaData?.isSkillLevelPassFailApplicable ?
            { ...this.getStepperIconAndColor(this.getPassFailGenericVal(status[1]?.status), this.getPassFailGenericVal(status[2]?.status)) }
            : { ...this.getStepperIconAndColor(midStatus) };
          let marks = (!this.campaignMetaData.isSkillLevelScoreNormalized) ? item?.totalScore?.toFixed(0) : item?.mainsTotal?.toFixed(0);
          obj['mains'] = { marks: marks, ...this.getStepTypeAndIcon('mains', item, status[2]?.status, !roundsAssignedToUser.includes('mains'), roundsAssignedToUser, item?.currentTestRoundIndex), ...mainsIcon };
        }
        else {
          let screeningStepAndIcon = { ...this.getStepTypeAndIcon('screening', item, item.isScreeningQuit ? 'SCREENING QUIT' : status[2]?.status, !roundsAssignedToUser.includes('screening'), roundsAssignedToUser, currentTestRoundIndex), ...this.getStepperIconAndColor(curentRound == 'screening' && item.status == 'CLOSED' ? 'closed' : this.getPassFailGenericVal(status[1]?.status), this.getPassFailGenericVal(item.isScreeningQuit ? 'SCREENING QUIT' : status[2]?.status)) }
          let mainsStepAndIcon = { ...this.getStepTypeAndIcon('mains', item, item.isMainsQuit ? 'MAINS QUIT' : status[4]?.status, !roundsAssignedToUser.includes('mains'), roundsAssignedToUser, currentTestRoundIndex), ...this.getStepperIconAndColor((curentRound == 'mains' && item.status == 'CLOSED') ? 'closed' : this.getPassFailGenericVal(status[3]?.status), this.getPassFailGenericVal(item.isMainsQuit ? 'MAINS QUIT' : status[4]?.status)) }
          let demoStepAndIcon = { ...this.getStepTypeAndIcon('demo', item, status[6]?.status, !roundsAssignedToUser.includes('demo'), roundsAssignedToUser, currentTestRoundIndex), ...this.getStepperIconAndColor(curentRound == 'demo' && item.status == 'CLOSED' ? 'closed' : this.getPassFailGenericVal(status[5]?.status), this.getPassFailGenericVal(status[6]?.status)) }
          let interveiwStepAndIcon = { ...this.getStepTypeAndIcon('interview', item, status[8]?.status, !roundsAssignedToUser.includes('interview'), roundsAssignedToUser, currentTestRoundIndex), ...this.getStepperIconAndColor(curentRound == 'interview' && item.status == 'CLOSED' ? 'closed' : this.getPassFailGenericVal(status[7]?.status), this.getPassFailGenericVal(status[8]?.status)) }
          obj['screening'] = { marks: item?.screeningTotal?.toFixed(0), ...screeningStepAndIcon }
          obj['mains'] = { marks: item?.mainsTotal?.toFixed(0), ...mainsStepAndIcon }
          obj['demo'] = { marks: item?.cumulativeNetDemoScore?.toFixed(0), ...demoStepAndIcon }
          obj['interview'] = { marks: this.calculateInterview(item?.interViewFeedback)?.toFixed(0), ...interveiwStepAndIcon }
        }
        this.stepper.set(index, obj)
        obj = {}
      })
    },
    getStepTypeAndIcon(stage, data, stateStatus, isStepSkipped = false, roundsAssignedToUser = [], currentTestRoundIndex = 0) {
      let curStatus = this.getCurrentStatus(data?.campaignStatus)
      let passFailVal = this.getPassFailGenericVal(stateStatus);
      let isApplicationClosed = this.showIcon(stage, curStatus, data?.status === 'CLOSED', roundsAssignedToUser, currentTestRoundIndex, data?.status === 'CLOSED');
      let isScreeningQuit = data?.isScreeningQuit;
      let isMainsQuit = data?.isMainsQuit;
      let isHREvaluate = this.showIcon(stage, curStatus, data?.isHREvaluate, roundsAssignedToUser, currentTestRoundIndex, data?.status === 'CLOSED')
      let isTakeLater = this.showIcon(stage, curStatus, data?.isTakeLater, roundsAssignedToUser, currentTestRoundIndex, data?.status === 'CLOSED')
      let iconName = isApplicationClosed ? 'closeApplicationIcon.svg' : isHREvaluate ? 'hourglass.svg' : isTakeLater ? 'schedule_1.svg' : isMainsQuit || isScreeningQuit ? 'quit.svg' : ''
      return {
        iconName,
        stepType: isStepSkipped ? 'showSkippedIcon' : ['failed', 'passed'].includes(passFailVal) ? 'showMarks' : isHREvaluate || isTakeLater || isApplicationClosed || (stage == 'screening' && isScreeningQuit) || (stage == 'mains' && isMainsQuit) ? 'showActionIcon' : 'showStepperIcon'
      }
    },
    getStepperIconAndColor(prevStatus = '', curStatus = '') {

      let map = new Map([
        ['started', { name: 'mdi-dots-horizontal-circle-outline', iconColor: 'blue' }],
        ['startedfailed', { name: 'mdi-close-circle', iconColor: 'red' }],
        ['startedpassed', { name: 'mdi-check-circle', iconColor: 'green' }],
        ['failed', { name: 'mdi-circle-double', iconColor: 'grey' }],
        ['failedpassed', { name: 'mdi-check-circle', iconColor: 'green' }],
        ['failedstarted', { name: 'mdi-dots-horizontal-circle-outline', iconColor: 'blue' }],
        ['passed', { name: 'mdi-circle-double', iconColor: 'grey' }],
        ['passedfailed', { name: 'mdi-close-circle', iconColor: 'red' }],
        ['passedstarted', { name: 'mdi-dots-horizontal-circle-outline', iconColor: 'blue' }],
        ['closed', { name: 'mdi-circle-double', iconColor: '#FB7500' }],
        ['quit', { name: 'mdi-circle-double', iconColor: '#E30C78' }],
        ['startedquit', { name: 'mdi-circle-double', iconColor: '#E30C78' }],
        ['failedquit', { name: 'mdi-circle-double', iconColor: '#E30C78' }],
        ['passedquit', { name: 'mdi-circle-double', iconColor: '#E30C78' }],
        ['startedclosed', { name: 'mdi-circle-double', iconColor: '#FB7500' }],
        ['skippedskipped', { name: 'mdi-circle-double', iconColor: 'grey' }],
        ['', { name: 'mdi-circle-double', iconColor: 'grey' }],
        ['closedskipped', { name: 'mdi-circle-double', iconColor: '#FB7500' }],
        ['startedskipped', { name: 'mdi-dots-horizontal-circle-outline', iconColor: 'blue' }]

      ])
      let key = prevStatus.trim() + curStatus.trim()
      return map.get(key)

    },
    getPassFailGenericVal(status = '') {
      if (status !== null && status !== undefined && status !== '') {
        return status.split(' ')[1]?.toLowerCase().trim()
      } else { return '' }

    },
    addDemoInterviewScore() {
      this.users = this.users.map((user) => {
        let noOfRounds = user?.numberOfRounds || [];
        let currentTestRoundIndex = user.hasOwnProperty('currentTestRoundIndex') ? user.currentTestRoundIndex : -1
        let screeningSkippedStatus = [{ 'status': 'SCREENING SKIPPED' }, { 'status': 'SCREENING SKIPPED' }]
        let mainsSkippedStatus = [{ 'status': 'MAINS SKIPPED' }, { 'status': 'MAINS SKIPPED' }]
        let demoSkippedStatus = [{ 'status': 'DEMO SKIPPED' }, { 'status': 'DEMO SKIPPED' }]
        if (noOfRounds.length > 0) {
          if (!noOfRounds.includes('screening') && this.campaignMetaData.numberOfRounds.includes('screening')) {
            user.campaignStatus.splice(1, 0, ...screeningSkippedStatus)
          }
          if (!noOfRounds.includes('mains') && this.campaignMetaData.numberOfRounds.includes('mains')) {
            user.campaignStatus.splice(3, 0, ...mainsSkippedStatus)
          }

          if (!noOfRounds.includes('demo') && this.campaignMetaData.numberOfRounds.includes('demo')) {
            user.campaignStatus.splice(5, 0, ...demoSkippedStatus)
          }

        }

        if (user.userType !== 'Teacher' && (user?.demoStatus || noOfRounds[currentTestRoundIndex] == 'interview' || noOfRounds[currentTestRoundIndex - 1] == 'interview')) {
          user.enableScheduleInterview = true
        }
        if (user?.demoStatus) {
          if (user.campaignStatus.filter((item) => item.status.includes('DEMO')).length == 0) {
            user.campaignStatus.push({ status: 'DEMO STARTED' })
            if (user?.demoScores) {
              user.campaignStatus.push({ status: 'DEMO PASSED' })
            }
          }

        }

        if (user?.interViewFeedback) {
          if (user.campaignStatus.filter((item) => item.status.includes('INTERVIEW')).length == 0) {
            user.campaignStatus.push({ status: 'INTERVIEW STARTED' })
            user.campaignStatus.push({ status: 'INTERVIEW PASSED' })
          }
        }
        if (user?.interviewFinalStatus?.status && user.interviewFinalStatus.status === "ROUND_ACCEPTED") {
            user.enableScheduleInterview = true
          }
        return user
      })

    },
    getRankQuery(rank) {
      return this.rankData?.find(rankQueryMap => rankQueryMap.name == rank)?.value ?? [];
    },
    async fetchCampaignAudience(isStatusTabSwitch = false) {

      try {
        if (this.campaignAudienceAbortController) {
          this.campaignAudienceAbortController.abort();
        }

        this.campaignAudienceAbortController = new AbortController();
        const { signal } = this.campaignAudienceAbortController;
        let body = {}
        let schools = this.selectedLocationFilters.length
          ? this.selectedLocationFilters
          : this.$store.state.userInfo.role.schools != "All"
            ? [this.$store.state.userInfo.role.schools]
            : [];
        let clusters = this.roleCluster ? [this.roleCluster] : this.selectedClusterFilters;
        if (this.filterCount) {
          this.selectedSort = "";
          this.sortCol = "mainsTotal";
          this.sortOrder = "desc";
          this.isFilterLoading = true;
          !this.isCustomDate ? this.getDateRange() : '';

          body = {
            clusters: clusters,
            latestStatus: this.getLatestStatusFromFilter,
            interviewAcceptedRounds: this.interviewAcceptedRoundsFilter,
            interviewRejectedRounds: this.interviewRejectedRoundsFilter,
            userCreatedAt: this.sendSelectedDateFilter ?? [],
            levels: this.selectedLevelFilters,
            leagues: this.selectedLeagueFilters,
            schools: schools,
            jobRole: this.selectedJobRolesFilters,
            subjects: this.selectedSubjectFilters,
            departments: this.selectedDepartmentFilter,
            rank: this.selectedRankFilters ?? [],
            candidateDecision: this.candidateDecisionFilter ?? {},
            sources: this.selectedSourceFilter,
            group: this.selectedGroupFilter,
            filterApplied: this.filterCount >= 2 || (this.filterCount > 0 && (this.roleCluster !== '' || this.roleSchool !== '' || this.interviewRejectedRoundsFilter.length > 0 || this.interviewAcceptedRoundsFilter.length > 0))
          }
        }
        else {
          body = {
            schools: schools,
            clusters: clusters

          }
        }
        console.log('body', body)
        let demoFilters = this.selectedDemoFilters;
        let mainsFilters = this.selectedMainsFilters?.flat();
        let screeningFilters = this.selectedScreeningFilters;
        let onBoardingFilters = this.selectedOnBoardingDecisionFilter;
        let afterScreeningDecisionFilter = this.selectedAfterScreeningDecisionFilter;
        let afterMainsDecisionFilter = this.selectedAfterMainsDecisionFilter;
        const { userCreatedAt, ...rest } = body;
        this.filters = {
          ...rest,
          ...(demoFilters.length > 0 ? { demoFilters } : {}),
          ...(mainsFilters.length > 0 ? { mainsFilters } : {}),
          ...(screeningFilters.length > 0 ? { screeningFilters } : {}),
          ...(onBoardingFilters.length > 0 ? { onBoardingFilters } : {}),
          ...(afterMainsDecisionFilter.length > 0 ? { afterMainsDecisionFilter } : {}),
          ...(afterScreeningDecisionFilter.length > 0 ? { afterScreeningDecisionFilter } : {}),
        }
        if (this.isCustomDate) {
          Object.assign(this.filters, this.sendSelectedDateFilter);
        }
        else {
          this.filters.dateRange = this.selectedDateFilters;
        }
        this.updateUrlParams()

        body.rank = this.getRankQuery(this.selectedRankFilters);
        this.preSearchUser = [];
        this.users = [];
        this.dataTableLoading = true;
        let query = "?campaignId=" + this.id + "&itemsPerPage=" + this.pageSize + "&page=" + this.page + "&sortOrder=" + this.sortOrder + "&sortCol=" + this.sortCol;
        if (this.search) {
          query += "&search=" + encodeURIComponent(this.search);
        }
        if (this.selectedStatus !== "ALL") {
          query += `&status=${this.selectedStatus}`;
        }
        if (this.currentSelectedStatus != null) {
          if (this.currentSelectedStatus != 'ALL') {
            query += `&status=${this.currentSelectedStatus}`;
          }

        }
        if (!isStatusTabSwitch) this.setStatusCounts(query, body);
        const audienceData = await CampaignController.getCampaignAudience(query, body, signal);
        this.preSearchUser = audienceData.result.users
        this.totalUsers = audienceData.result.totalUsers;
        this.campaignName = audienceData.result.campaignName;
        let preUsers = this.preSearchUser

        this.users = this.preSearchUser;
        this.users = this.calculateUsersForLeague(preUsers);
        this.users = this.users.map(user => {
          if (user.coreSkillsSubject.length > 0 && user.coreSkillsSubject != undefined) {
            let leagueArray = user.coreSkillsSubject.map(subject => subject.league);
            user['NoLeague'] = leagueArray.every((item) => { return item == 'Not Eligible' });
          }
          return user;
        }
        )
        this.addDemoInterviewScore()
        this.createStepperData(this.users)
        this.addInterviewScoreAndModifyVals(this.users)

      }
      catch (error) {
        console.error("Errror", error)
      }
      finally {
        this.dataTableLoading = false;
        this.isFilterLoading = false;
        this.filterDialog = false;
      }
    },
    async setStatusCounts(query, body) {

      try {

        if (this.setStatusCountsAbortController) {
          this.setStatusCountsAbortController.abort();
        }
        this.setStatusCountsAbortController = new AbortController();
        const { signal } = this.setStatusCountsAbortController;
        const { result } = await CampaignController.getAudienceStatusCounts(query, body, signal);
        this.statusMap = result.statusCounts;
      }
      catch (error) {
        console.log('failed to fetch audience counts:', error);
      }
    },
    async setupSnapshotListenerFunnel(id) {
      // Switching campaigns (route query id changes) reuses this component instance rather
      // than remounting it, so this can run more than once per instance - tear down the
      // previous campaign's listener first, otherwise both stay live and whichever fires
      // last (potentially the stale one) overwrites chartData with the wrong campaign's data.
      if (this.funnelUnsubscribe) {
        this.funnelUnsubscribe();
        this.funnelUnsubscribe = null;
      }

      let schools = this.$store.state.role.schools;
      let cluster = this.$store.state.role.clusterName

      // Firestore path segments must be non-empty strings. Depending on the
      // user's scope, id / role.schools / role.clusterName can arrive as
      // undefined or as an array; passing either to doc() throws
      // "n.split is not a function". Normalise and validate before building
      // the ref, and skip the listener if a required segment is missing.
      const toSegment = (value) => (Array.isArray(value) ? value[0] : value);
      const isValidSegment = (value) =>
        typeof value === "string" && value.trim().length > 0;

      id = toSegment(id);
      schools = toSegment(schools);
      cluster = toSegment(cluster);

      if (!isValidSegment(id)) {
        console.warn("setupSnapshotListenerFunnel: invalid campaign id, skipping listener", id);
        return;
      }

      let dashboardTeachersRef;
      if (cluster === "All Clusters") {
        dashboardTeachersRef = doc(
          db,
          "dashboards",
          "management-dashboard-001",
          "campaigns",
          id,
        );
      }
      else if (schools === "All") {
        if (!isValidSegment(cluster)) {
          console.warn("setupSnapshotListenerFunnel: invalid cluster, skipping listener", cluster);
          return;
        }
        dashboardTeachersRef = doc(
          db,
          "dashboards",
          "management-dashboard-001",
          "campaigns",
          id,
          "clusters",
          cluster,
        );
      }
      else {
        if (!isValidSegment(schools)) {
          console.warn("setupSnapshotListenerFunnel: invalid school, skipping listener", schools);
          return;
        }
        dashboardTeachersRef = doc(
          db,
          "dashboards",
          "management-dashboard-001",
          "campaigns",
          id,
          "schools",
          schools
        );
      }

      try {
        this.funnelUnsubscribe = onSnapshot(dashboardTeachersRef, (snapshot) => {
          this.chartData = { ...this.emptyChartData };

          const resultData = snapshot.data() || {};

          const requiredKeys = [
            "invited",
            "screeningStarted",
            "screeningPassed",
            "screeningFailed",
            "mainsStarted",
            "mainsPassed",
            "mainsFailed",
            "demoSubmitted",
            "interviewSubmitted",
          ];

          const hasMissingData = requiredKeys.some((key) => resultData[key] === undefined);

          if (hasMissingData) {
            return;
          }

          Object.assign(this.chartData, resultData);

          this.invited = this.chartData.invited;
          this.screeningStarted = this.chartData.screeningStarted;
          this.screeningSkipped = this.chartData.screeningSkipped;
          this.demoSkipped = this.chartData.demoSkipped;
          this.screeningPassed = this.chartData.screeningPassed;
          this.mainsStarted = this.chartData.mainsStarted;
          this.mainsSkipped = this.chartData.mainsSkipped
          this.mainsPassed = this.chartData.mainsPassed;
          this.screeningFailed = this.chartData.screeningFailed;
          this.mainsFailed = this.chartData.mainsFailed;
          this.apraisals = this.chartData.mainsPassed;
          this.mainsAttempted = this.mainsPassed + this.mainsFailed;
          this.pip = this.chartData.mainsFailed;
          this.tbd = this.chartData.screeningFailed;
          this.chartData.mainsAttempted = this.mainsAttempted;
        });
        this.liveListenersToUnsubscribeMixin.push(this.funnelUnsubscribe);

      } catch (error) {
        console.error("Error checking document existence or setting up snapshot:", error);
      }
    },

    calculateUsersForLeague(users) {
      users.forEach((user) => {
        var coreSkills = [];
        if (user.coreSkillsSubject !== undefined) {
          user.coreSkillsSubject.forEach((coreSkillSubject) => {
            if (coreSkillSubject.result == "PASSED") {
              coreSkills.push(coreSkillSubject);
            }
          });
        }
        user.coreSkillsSubject = coreSkills;
      });
      return users;
    },
    async sendInvitationReminders() {
      const formattedUsers = this.selectedUsers.map(({ userId, personalInfo }) => {
        const { firstName = '', lastName = '', contactInfo: { email } } = personalInfo;
        const userName = `${firstName} ${lastName}`
        return { userId, userName, email }
      })

      const result = await CampaignController.sendAssessmentReminders(this.id, formattedUsers, this.$store.state.userInfo.email);
      this.assessmentReminderSnackBar = result.flag;
      return;

    },
    async addUserToRemindList(user) {
      this.selectedUsers.push(user);
      await this.sendInvitationReminders();
      this.selectedUsers = [];
    },
    isRowDisabled(item) {
      return item?.campaignStatus.length > 1
    },
    toggleSelectAll(checked) {
      if (!checked) {
        this.selectedUsers = [];
        return;
      }
      this.selectedUsers = this.users.filter(user => !this.isRowDisabled(user))
    },
    calculatePercentage(value, total) {
      if (total === 0) {
        return 0;
      }
      const percentage = (value / total) * 100;
      if (isNaN(percentage)) {
        return 0;
      }
      const roundedPercentage = Math.round(percentage);
      return roundedPercentage;
    },
    async fetchAllClusters() {
      const response = await ClusterController.getAllClusters();

      if (response.status == 200) {
        if (response.data.clusters.length > 0) {
          this.clusters = response.data.clusters;
        } else {
          this.clusters = [];
        }
      } else {
        alert(response.data.error);
      }
    },
    async getBoards() {
      const response = await BoardController.getBoards();
      if (response.status == 200) {
        this.count = response.data.count;
        if (response.data.boards.length > 0) {
          this.boardsData = response.data.boards;
        }
      } else {
        alert(response.data.error);
      }
    },
    getHrEvaluationStage(obj) {
      return Object.entries(obj).find((item) => item[1].iconName == 'hourglass.svg')[0]
    },

    getLatestStatus(campaignStatus) {
      return campaignStatus[campaignStatus.length - 1]?.status;
    },

    canRestartExam(campaignStatus, item) {

      if (item.demoStatus === true || !this.$store.state.userInfo?.role?.canRestartAssessment?.read) {
        return false;
      }
      const latestStatus = item?.filters?.latestStatus;
      return ['PASSED', 'FAILED'].some(result => latestStatus?.includes(result));
    },
    handleRestartClick(item) {
      this.restartAssessmentDialog = true;
      this.userForClearAssessment = item.userId;
      this.currentUserType = item.userType;
      this.currentCampaignStatus = this.getLatestStatus(item.campaignStatus);
    },
    handleInterviewHistoryClick(data) {
      this.$router.push({
        path: "/interview-history",
        name: "InterviewHistory",
        query: {
          campaignId: this.id,
          userId: data.userId,
          redirectedFrom: 'campaigns'
        },
      });
    },

    async clearUserAssessment(userId) {
      this.restartAssessmentLoader = true;
      const response = await CampaignController.clearUserAssessment(userId, this.id, this.$store.state.userInfo.email);
      this.restartAssessmentDialog = false;
      this.restartAssessmentLoader = false;
      if (response.flag == true) {
        this.clearUserAssessmentSuccessSnackbar = true;
      } else {
        alert(response.result);
        this.clearUserAssessmentFailureSnackbar = true;
      }
    },
    openCloseApplicationDialog({ userId }) {
      this.closeApplicationForUser.userId = userId;
      this.closeApplicationForUser.remarksInfo.remarks = '';
      this.closeApplicationDialog = true;
    },
    disableCloseApplicationOption(user) {
      return !['Not Applicable', 'Not Scheduled'].includes(this.getStatusClass(user).statusName)
    },
    async closeApplication() {
      this.closeApplicationLoader = true;
      this.closeApplicationForUser.remarksInfo.closedBy = {
        userName: this.$store.state.userInfo.name,
        email: this.$store.state.userInfo.email,
      };
      const { userId, ...rest } = this.closeApplicationForUser
      const response = await UsersController.updateUser(userId, rest);
      if (response.flag) {
        this.closeApplicationLoader = false;
        this.closeApplicationDialog = false;
        this.closeApplicationSuccessDialog = true;

        await this.fetchCampaignAudience();
      }
    },
    async switchStatusTab() {
      this.page = 1;
      this.currentPage = 1;
      await this.fetchCampaignAudience(true);
    },
    onEditorReady(editor) {
      editor.on("afterCommandExec", function (event) {
        var commandName = event.data.name;
        if (['ckeditor_wiris_openFormulaEditor', 'ckeditor_wiris_openFormulaEditorChemistry'].includes(commandName)) {
          setTimeout(() => {
            const wiris_license_overlays = document.querySelectorAll('.wrs_tickContainer')
            wiris_license_overlays.forEach(element => {
              element.remove();
            });
          }, 2000)
        }
      })
    },
    onEditorInput() {
      this.remarksLength = this.stripHtml(this.closeApplicationForUser.remarksInfo.remarks).length
    },
    stripHtml(html) {
      const div = document.createElement('div');
      div.innerHTML = html;
      return div.textContent || div.innerText || '';
    },
    showIcon(stage = "", curStatus, flag = false, roundsAssignedToUser, currentTestRoundIndex, isClosed = false) {
      if (stage == roundsAssignedToUser[currentTestRoundIndex]) {
        return flag
      }
    },
    getCurrentStatus(data) {
      data = data.filter(item => !item?.status.includes('APPLICATION') && !item?.status.includes('SKIPPED'));
      return data[data.length - 1]?.status.split(' ')[0].toLowerCase()
    },
    async recommendedJobseekerCountListener() {
      const campaignDocRef = doc(db, "campaigns", this.id);
      let unsubscribe = onSnapshot(campaignDocRef, async (docSnapshot) => {
        this.recommendedJobseekerCount = 0;
        if (docSnapshot.exists()) {
          const campaignData = docSnapshot.data();
          if (campaignData.audienceType.toLowerCase() === "job_seeker" ||
            campaignData.audienceType.toLowerCase() === "jobseeker" ||
            campaignData.audienceType.toLowerCase() === "job seeker") {
            try {
              const jobSeekerSchoolCluster = campaignData.clusters ?? [];

              const jobSeekerRef = collection(campaignDocRef, "audience");
              const jobSeekDocs = await getDocs(jobSeekerRef);

              for (const d of jobSeekDocs.docs) {
                const jobSeekerData = d.data();

                const schoolName = this.$store.state.role.schools;
                const clusterName = this.$store.state.role.clusterName;
                const jobSeekerSchoolName = jobSeekerData.teachingInterests?.schools ?? [];

                if (
                  (clusterName === "All Clusters" && schoolName === "All") ||
                  (clusterName !== "All Clusters" && schoolName === "All" &&
                    ((typeof jobSeekerSchoolCluster === 'string' && jobSeekerSchoolCluster === clusterName) ||
                      (Array.isArray(jobSeekerSchoolCluster) && jobSeekerSchoolCluster.includes(clusterName)))) ||
                  (clusterName !== "All Clusters" &&
                    ((typeof jobSeekerSchoolName === 'string' && jobSeekerSchoolName === schoolName) ||
                      (Array.isArray(jobSeekerSchoolName) && jobSeekerSchoolName.includes(schoolName))))
                ) {
                  if (jobSeekerData?.campaignStatus?.length === 5 &&
                    jobSeekerData?.demoStatus &&
                    jobSeekerData?.coreSkillsSubject?.length > 0 &&
                    jobSeekerData?.interViewFeedback?.length > 0) {
                    let netScoreMains = 0;
                    let netScoreInterview = 0;
                    for (const dt of jobSeekerData.coreSkillsSubject) {
                      if (dt.league !== "Not Eligible") {
                        try {
                          netScoreMains += parseFloat(dt.finalNetScore);
                        } catch (error) {
                          console.error("Error parsing mains score:", error);
                        }
                      }
                    }

                    for (const interview of jobSeekerData.interViewFeedback) {
                      try {
                        netScoreInterview += parseFloat(interview.avgScore);
                      } catch (error) {
                        console.error("Error parsing interview score:", error);
                      }
                    }
                    netScoreMains /= jobSeekerData.coreSkillsSubject.length;
                    netScoreInterview /= jobSeekerData.interViewFeedback.length;
                    const netFinalRecommendationScore = (netScoreMains + netScoreInterview) / 2;
                    if (netFinalRecommendationScore >= 0) {
                      this.recommendedJobseekerCount += 1;
                    }
                  }
                }
              }
            } catch (error) {
              console.error("Error processing campaign document:", error);
            }
          }
        } else {
          console.log("Campaign document does not exist");
        }
      });
      this.liveListenersToUnsubscribeMixin.push(unsubscribe);
    },

    async goToRecommendedForHiring() {
      try {
        this.$router.push({
          path: "/jobseekerstbd",
          name: "jobseekerstbd",
          query: {
            id: this.id,
          },
        });
      } catch (error) {
        console.error("Error navigating to recommended job seekers:", error);
      }
    },
    async goToJobSeekersInterviewed() {
      try {
        this.$router.push({
          path: "/jobseekerspip",
          name: "jobseekerspip",
          query: {
            id: this.id,
          },
        });
      } catch (error) {
        console.error("Error navigating to recommended job seekers:", error);
      }
    },
    async goToJobSeekersAppraisal() {
      try {
        this.$router.push({
          path: "/jobseekersappraisal",
          name: "jobseekersappraisal",
          query: {
            id: this.id,
          },
        });
      } catch (error) {
        console.error("Error navigating to recommended job seekers:", error);
      }
    },
    handleSearchInput() {
      this.debouncedSearch();
      this.updateUrlParams();
    },
    performSearch() {
      this.page = 1
      this.currentPage = 1
      this.fetchCampaignAudience()
    },
    updateUrlParams() {
      const query = {
        id: this.id,
        campaignType: this.$route.query.campaignType,
      };

      if (this.search) {
        query.search = this.search;
      }
      if (Object.keys(this.filters)) {
        Object.assign(this.filters, query);
      }
      this.$router.push({
        query: this.filters
      }).catch(() => { });
    },
    selectSortOption(sortOption) {
      this.selectedSort = sortOption;
      switch (sortOption) {
        case "nameAsc":
          this.sortCol = "name";
          this.sortOrder = "asc";
          break;
        case "nameDesc":
          this.sortCol = "name";
          this.sortOrder = "desc";
          break;
        case "emailAsc":
          this.sortCol = "email";
          this.sortOrder = "asc";
          break;
        case "emailDesc":
          this.sortCol = "email";
          this.sortOrder = "desc";
          break;
        case "dateNewest":
          this.sortCol = "createdOn";
          this.sortOrder = "desc";
          break;
        case "dateOldest":
          this.sortCol = "createdOn";
          this.sortOrder = "asc";
          break;
        default:
          this.selectedSort = "";
          this.sortCol = "mainsTotal";
          this.sortOrder = "desc";
      }
      this.options.page = 1;
      this.fetchCampaignAudience();
    },
    async getSchool() {
      const response = await SchoolController.getSchool();
      if (response.status === 200) {
        this.locationData = response.data.schools;
      }
    },
    async getLeagues() {
      const response = await LeagueController.getLeagues();
      if (response.status === 200) {
        this.leagueData = response.data.leagues;
      }
    },
    async getRank() {
      return;
    },
    async getJobRoles() {
      const response = await AudienceRolesController.getAudienceRoles("");
      if (response.status === 200) {
        this.jobRolesData = response.data.audienceRoles;
      }

    },
    async getLevels() {
      const response = await LevelController.getLevel();
      if (response.status === 200) {
        this.levelData = response.data.levels;
      }
    },
    async getSubject() {
      const response = await SubjectController.getSubject();
      if (response.status === 200) this.subjectData = response.data.subjects;
    },

    addCustomDates() {
      this.selectedDateFilters = 'custom_date';
      if (this.customStartDate && this.customEndDate) {
        this.sendSelectedDateFilter = {
          start: format(new Date(this.customStartDate), 'yyyy-MM-dd 00:00:00'),
          end: format(new Date(this.customEndDate), 'yyyy-MM-dd 23:59:59')
        };
        this.menu = false;
      }
    },

    async getDepartments() {
      const response = await AudienceRolesController.getDepartments();
      if (response?.data?.flag) {
        this.departmentData = response.data.departments;
      }
    },

    async getSchoolCities() {
      const response = await ClusterController.getClusterCities();

      if (response?.data?.flag) {
        this.schoolCitiesData = response.data.uniqueClusters;
      }
    },
    updateDecisionStatusFilter() {
      this.selectedCandidateDecisionFilter = []
      // Onboarding decisions
      if (this.selectedOnBoardingDecisionFilter.length > 0) {
        this.candidateDecisionFilter.onboarding = this.selectedOnBoardingDecisionFilter;
      }
      else {
        this.candidateDecisionFilter.onboarding = []
      }

      // Screening decisions
      if (this.selectedAfterScreeningDecisionFilter.length > 0) {
        this.candidateDecisionFilter.quickfitment = this.selectedAfterScreeningDecisionFilter;

      }
      else {
        this.candidateDecisionFilter.quickfitment = []
      }

      // Mains decisions
      if (this.selectedAfterMainsDecisionFilter.length > 0) {
        this.candidateDecisionFilter.detailfitment = this.selectedAfterMainsDecisionFilter;
      }
      else {
        this.candidateDecisionFilter.detailfitment = [];
      }


      this.selectedCandidateDecisionFilter = [...this.selectedOnBoardingDecisionFilter, ...this.selectedAfterScreeningDecisionFilter, ...this.selectedAfterMainsDecisionFilter]
    },

    updateSelectedRounds() {
      const interviewStatusSet = new Set();
      this.interviewAcceptedRoundsFilter = [];
      this.interviewRejectedRoundsFilter = [];
      for (const idx of this.selectedInterviewsFilters) {
        const interview = this.interviewsData[idx].value;
        const round = this.interviewsData[idx].round;
        interviewStatusSet.add(interview);
        if (round) {
          if (interview === 'ROUND_ACCEPTED') {
            !this.interviewAcceptedRoundsFilter.includes(round) ? this.interviewAcceptedRoundsFilter.push(round) : null;
          }
          else if (interview === 'REJECT') {
            !this.interviewRejectedRoundsFilter.includes(round) ? this.interviewRejectedRoundsFilter.push(round) : null;
          }
        }
      }
      this.selectedInterviewsFiltersWithRounds = Array.from(interviewStatusSet);
    },

    measureCommentTruncation() {
      this.$nextTick(() => {
        requestAnimationFrame(() => this.computeCommentTruncation());
      });
    },

    computeCommentTruncation(attempt = 0) {
      const refs = this.$refs.commentRefs;
      const commentNodes = Array.isArray(refs) ? refs : refs ? [refs] : [];
      const layoutReady =
        commentNodes.length &&
        commentNodes.every((node) => node.parentElement && node.parentElement.clientHeight > 0);
      if (!layoutReady) {
        if (attempt < 5) {
          requestAnimationFrame(() => this.computeCommentTruncation(attempt + 1));
        }
        return;
      }

      const truncationByInterviewer = {};
      commentNodes.forEach((node) => {
        const row = node.parentElement;
        if (!row) return;
        node.style.webkitLineClamp = '';
        const styles = getComputedStyle(node);
        const lineHeight = parseFloat(styles.lineHeight) || parseFloat(styles.fontSize) * 1.45;
        const visibleLines = Math.max(1, Math.floor(row.clientHeight / lineHeight));
        node.style.webkitLineClamp = String(visibleLines);
        truncationByInterviewer[node.dataset.interviewer] = node.scrollHeight > node.clientHeight + 1;
      });
      this.truncatedComments = truncationByInterviewer;
    },

    async downloadAttendanceCSV() {
      try {
        this.downloadingAttendance = true;

        const body = {
          campaignId: this.id,
          userId:     this.feedbackUser.userId,  // whatever your data property is
          round:      this.feedbackUser.round,
        };

        const response = await CampaignController.downloadInterviewAttendanceReport(body);

        if (response.status !== 200) {
          throw new Error("Failed to download CSV");
        }

        const url      = window.URL.createObjectURL(new Blob([response.data], { type: "text/csv" }));
        const link     = document.createElement("a");
        link.href      = url;
        link.setAttribute("download", `Interview_Attendance_Round${this.feedbackUser.round}.csv`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

      } catch (error) {
        console.error("Attendance download failed:", error);
      } finally {
        this.downloadingAttendance = false;
      }
    }
  },

  async created() {
    console.log('this.$route.query',this.$route.query)
    this.currentCampaignId = this.$route.query.id;
    this.$store.commit('clearFirstFullPath');
    this.$store.commit('setFirstFullPath', "/");
    this.id = this.$route.query.id;

    // Read all query params synchronously BEFORE the await so that mounted()
    // sees the correct values when it calls fetchCampaignAudience → updateUrlParams.
    this.campaignType = this.$route.query.campaignType;
    const { search, clusters, screeningFilters, mainsFilters, demoFilters, start, end, dateRange, levels, leagues, schools, jobRole, subjects, departments, rank, sources, onBoardingFilters, afterMainsDecisionFilter, afterScreeningDecisionFilter } = this.$route.query;
    this.search = search || "";
    this.roleCluster = (this.$store.state.userInfo?.role?.clusterName && this.$store.state.userInfo?.role?.clusterName != "All Clusters") ? this.$store.state.userInfo?.role?.clusterName : "";
    this.roleSchool = (this.$store.state.userInfo?.role?.schools && this.$store.state.userInfo?.role?.schools != "All" && this.$store.state.userInfo?.role?.schools?.length > 0) ? this.$store.state.userInfo?.role?.schools : "";
    this.selectedClusterFilters = !this.roleCluster ? Array(clusters || []).flat() : [];
    this.selectedLocationFilters = !this.roleSchool ? Array(schools || []).flat() : [];
    this.selectedLevelFilters = Array(levels || []).flat();
    this.selectedLeagueFilters = Array(leagues || []).flat();
    this.selectedJobRolesFilters = Array(jobRole || []).flat();
    this.selectedSubjectFilters = Array(subjects || []).flat();
    this.selectedDepartmentFilter = Array(departments || []).flat();
    this.selectedSourceFilter = Array(sources || []).flat();
    this.selectedAfterMainsDecisionFilter = Array(afterMainsDecisionFilter || []).flat();
    this.selectedAfterScreeningDecisionFilter = Array(afterScreeningDecisionFilter || []).flat();
    this.selectedOnBoardingDecisionFilter = Array(onBoardingFilters || []).flat();
    this.updateDecisionStatusFilter();
    this.selectedRankFilters = rank || null;
    if (dateRange) {
      this.selectedDateFilters = dateRange;
      this.getDateRange();
    }
    else if (start && end) {
      this.selectedDateFilters = 'custom_date';
      this.customStartDate = start.split(" ")[0];
      this.customEndDate = end.split(" ")[0];
      this.sendSelectedDateFilter = { start, end };
    }
    this.selectedDemoFilters = Array(demoFilters || []).flat();
    this.selectedMainsFilters = Array(mainsFilters || []).flat();
    this.selectedScreeningFilters = Array(screeningFilters || []).flat();
    this.getFilterCount();
    this.debouncedSearch = debounce(this.performSearch, 300);

    await Promise.all([
      this.getCampaignMetaData(this.id),
      this.getAudienceRoleGroups()
    ]);
    this.setAudienceTableHeaders()
    this.fetchAllClusters();
    this.getBoards();
  },
};
</script>
<style scoped>
.feedback-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.feedback-card {
  height: 210px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: #ffffff;
}

.feedback-card--row {
  font-size: 13px;
  line-height: 1.45;
  color: rgba(0, 0, 0, 0.87);
  margin-bottom: 4px;
}

.feedback-card--label {
  flex: 0 0 auto;
  width: 112px;
  color: rgba(0, 0, 0, 0.6);
}

.feedback-card--dash {
  flex: 0 0 auto;
  margin: 0 6px;
  color: rgba(0, 0, 0, 0.6);
}

.feedback-card--value {
  flex: 1 1 auto;
  min-width: 0;
}

/* The comment fills the remaining card height and ellipsizes on overflow. */
.feedback-card--comment-row {
  flex: 1 1 auto;
  align-items: flex-start;
  overflow: hidden;
  margin-bottom: 0;
}

.feedback-card--comment {
  display: -webkit-box;
  -webkit-line-clamp: 5;
  line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.feedback-comment-tooltip {
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.feedback-card--clickable {
  cursor: pointer;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.feedback-card--clickable:hover {
  transform: translateY(-2px);
}

.feedback-help-text {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
}

.round-toggle {
  background: #f5f5f5;
  border-radius: 20px;
}

.round-toggle ::v-deep .v-btn {
  text-transform: none !important;
  letter-spacing: 0.5px;
}

.round-toggle ::v-deep .blue {
  background-color: #3F51B5 !important;
}

.round-toggle ::v-deep .gray-02 {
  background-color: transparent !important;
}

.feedback-scroll-container {
  max-height: 300px;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.feedback-scroll-container::-webkit-scrollbar {
  display: none;
}

.feedback-card--name {
  font-size: 14px;
  font-family: "GraphikMedium", sans-serif !important;
  font-weight: 500;
}

.feedback-card--pending {
  background-color: #f5f5f5;
}

.feedback-card--pending-text {
  font-size: 13px;
  color: rgba(0, 0, 0, 0.6);
}

.feedback-empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 120px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
}

.recommended-bg {
  background-color: var(--success-03);
}

.hold-bg {
  background-color: rgba(233, 182, 94, 0.24);
}

.rejected-bg {
  background-color: var(--error-01);
}

.text-color {
  color: #a3a3a3
}

.frozen-columns-table {
  width: 100%;
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.frozen-columns-table>>>thead {
  position: sticky !important;
  top: 0 !important;
  z-index: 50 !important;
}

.frozen-columns-table>>>.v-data-table__wrapper {
  overflow-x: auto;
  -ms-overflow-style: none !important;
  scrollbar-width: none !important;
}

.frozen-columns-table::-webkit-scrollbar {
  display: none;
  /* Hide scrollbar for Chrome, Safari and Opera */
}

.frozen-columns-table>>>th:nth-child(1),
.frozen-columns-table>>>td:nth-child(1) {
  position: sticky !important;
  left: 0;
  z-index: 9;
  background-color: white;
  white-space: nowrap;
  max-width: 190px;
  box-shadow: 5px 0 8px rgba(0, 0, 0, 0.1);
}

.frozen-columns-table>>>th:last-child,
.frozen-columns-table>>>td:last-child {
  position: sticky !important;
  right: 0;
  z-index: 7;
  background-color: white;
  box-shadow: -5px 0 8px rgba(0, 0, 0, 0.1);
}

.frozen-columns-table>>>tbody tr:hover td:first-child,
.frozen-columns-table>>>tbody tr:hover td:nth-child(2),
.frozen-columns-table>>>tbody tr:hover td:last-child {
  background-color: inherit !important;
  /* This will inherit the row's hover color */
}

.frozen-columns-table>>>th:nth-child(1),
.frozen-columns-table>>>th:nth-child(2),
.frozen-columns-table>>>th:last-child {
  background-color: #ebf2ff;
}

.disable-class {
  opacity: 0.5;
  cursor: default;
}

.multi-line-ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: auto;
  max-width: 120px;
}

.widened-multi-line-ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: auto;
  max-width: 250px;
}

.stepper-icon {
  height: auto;

}

.pass-step {
  color: green
}

.fail-step {
  color: var(--error);
}

.cardBorder {
  border: 1px solid rgba(0, 0, 0, 0.12) !important;
  margin: 0px;
}

.mdi-chevron {
  font-size: 24px !important;
}

.rounded-table {
  border-radius: 8px 8px 0px 0px !important;
}

.viewTestProctoringBox {
  border: 2px solid black;
  border-radius: 8px;
  margin-top: 8px;
  margin-bottom: 8px;
  padding: 8px;
}

.disabled-icon {
  opacity: 0.5;
  cursor: not-allowed;
}

::v-deep .v-data-table-header th {
  font-family: "GraphikMedium", sans-serif !important;
  font-weight: 500 !important;
  color: #333;
}

::v-deep .v-data-table>.v-data-table__wrapper>table>thead>tr>th {
  font-size: 14px !important;
}

.action-row {
  position: relative;
}

.notification-badge {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 4px;
  background: var(--light-red);
  font-size: 10px;
  border-radius: 20px;
  line-height: 16px;
  height: 20px;
  position: absolute;
  top: -10px;
  right: 0px;
}

.v-chip {
  padding: 11px 16px !important;
}

.accepted-status {
  background: var(--success-03) !important;
  color: var(--success-02);
}

.scheduled-status {
  color: blue;
  background: #3F41D12B !important;
}

.not-scheduled-status {
  background: var(--gray-03) !important;
  color: var(--gray-04);
}

.rejected-status {
  background: var(--error-03) !important;
  color: var(--red);
}

.closed-status {
  background: #F9DBED !important;
  color: #E30C78;
}

.on-hold-status {
  background: var(--light-yellow) !important;
  color: var(--orange);
}

.notify-hr-status {
  background: #EFDCF8 !important;
  color: #AF52DE;
}


.hiring-manager-status {
  background: #E8E3FF !important;
  color: #6D54E1;
}

.interview-completed-status {
  background: #CAEDF5 !important;
  color: #166475;
}

.copy-image {
  width: 24px;
  height: 24px;
}

.content-black-badge .v-badge__badge {
  color: black
}

.hide-scrollbar {
  overflow: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.hide-scrollbar::-webkit-scrollbar {
  display: none;
}


.mail-icon.v-icon {
  font-size: 65px !important;
  color: var(--blue-01)
}

.m-ckeditor {
  max-height: 200px;
}

.gap-16 {
  gap: 16px;
}

.close-application-dialog-title {
  font-weight: 500;
  font-family: 'GraphikMedium' !important;
  font-size: 20px;
}

.close-application-dialog-text {
  font-weight: 400;
  font-size: 16px;
}

.custom-data-table>>>.v-data-table__wrapper {
  overflow-y: auto !important;
  scrollbar-width: none !important;
  /* Firefox */
  -ms-overflow-style: none !important;
  /* IE and Edge */
}

.custom-data-table>>>.v-data-table__wrapper::-webkit-scrollbar {
  display: none !important;
  /* Chrome, Safari, Opera */
}

.view-feedback-dialog {
  overflow-y: none !important;
}
</style>
